/* =====================================================================
   sale26 — behaviour for the mega-sale layer (see assets/sale26.css)

   Every sale26 section includes this file, so it guards against running
   twice. It owns: campaign phases + rolling countdown, scroll reveals,
   headline word splits, hero depth, magnetic buttons and
   off-screen pausing of every loop. No library: IntersectionObserver and
   CSS transitions only, so a failed script leaves a complete static page.

   Campaign times are authored in GMT+8, so a phase flips at the same moment
   for every visitor wherever they are.
   ===================================================================== */
(() => {
  /* every sale26 section includes this file, so a page runs it ~20 times; only the first copy does
     anything (it inits on DOMContentLoaded, and on shopify:section:load in the theme editor) */
  if (window.__sale26) return;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  if (!reduced) document.documentElement.classList.add('s26-motion');

  const ts = (v) => { if (!v) return null; const t = Date.parse(String(v).trim().replace(' ', 'T') + '+08:00'); return isNaN(t) ? null : t; };
  const pad = (n) => String(n).padStart(2, '0');
  /* every date check on the page reads this clock, so the hero's "Preview as" setting (theme
     editor and unpublished previews only) moves the whole campaign to that moment */
  const nowMs = () => (window.__s26now ? window.__s26now() : Date.now());

  /* ---------- add to calendar: a two-item menu ----------
     A .ics download alone opens whatever owns .ics on the device (Outlook on most Windows PCs) and
     does nothing useful on Android phones that only have Google Calendar, so every calendar button
     opens this menu: Google Calendar (its "new event" page, prefilled) or Apple / Outlook (.ics).
     window.s26Cal.menu(button, { title, start, end (ms), details, url, alarm (minutes before), file }).
     The sections fall back to their own .ics download when this file isn't on the page. */
  window.s26Cal = (() => {
    const z = (ms) => new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const tx = (v) => String(v || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/[,;]/g, (m) => '\\' + m);
    const ICON_G = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16.5" rx="3" fill="#fff" stroke="#DADCE0"/><path d="M3 9h18" stroke="#DADCE0"/><rect x="3" y="4.5" width="18" height="4.5" rx="2" fill="#4285F4"/><text x="12" y="18.6" text-anchor="middle" font-family="Arial,sans-serif" font-size="8.5" font-weight="700" fill="#4285F4">31</text></svg>';
    const ICON_F = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v11M7.5 10.5 12 15l4.5-4.5M5 19.5h14"/></svg>';
    let pop = null, owner = null;
    function style() {
      if (document.getElementById('s26cal-css')) return;
      const st = document.createElement('style'); st.id = 's26cal-css';
      st.textContent = '.s26cal{position:fixed;z-index:2147483600;min-width:236px;padding:6px;border-radius:16px;background:#fff;color:#0D141C;box-shadow:0 1px 2px rgba(6,11,16,.12),0 18px 44px -12px rgba(6,11,16,.55);font:500 14px/1.2 "M-Body-Font",ui-sans-serif,system-ui,sans-serif;animation:s26cal-in .18s cubic-bezier(.23,1,.32,1)}'
        + '@keyframes s26cal-in{from{opacity:0;transform:translateY(-4px) scale(.98)}}'
        + '.s26cal a,.s26cal button{display:flex;align-items:center;gap:12px;width:100%;min-height:44px;padding:0 12px;border:0;border-radius:11px;background:none;color:inherit;font:inherit;text-align:left;text-decoration:none;cursor:pointer}'
        + '.s26cal a:hover,.s26cal button:hover,.s26cal a:focus-visible,.s26cal button:focus-visible{background:#EEF3F8;outline:none}'
        + '.s26cal svg{flex:none;width:22px;height:22px;color:#0099FF}.s26cal small{margin-left:auto;padding-left:10px;font-size:12px;color:#6B7480}'
        + '@media (prefers-reduced-motion:reduce){.s26cal{animation:none}}';
      document.head.appendChild(st);
    }
    function ics(ev) {
      const alarm = ev.alarm == null ? 10 : ev.alarm;
      const body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//EPOMAKER//Sale//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
        'UID:' + z(ev.start) + '-' + Math.random().toString(36).slice(2) + '@' + location.hostname,
        'DTSTAMP:' + z(Date.now()), 'DTSTART:' + z(ev.start), 'DTEND:' + z(ev.end && ev.end > ev.start ? ev.end : ev.start + 3600e3),
        'SUMMARY:' + tx(ev.title), 'DESCRIPTION:' + tx([ev.details, ev.url].filter(Boolean).join('\n\n')), 'URL:' + (ev.url || ''),
        'BEGIN:VALARM', 'ACTION:DISPLAY', 'TRIGGER:-PT' + alarm + 'M', 'DESCRIPTION:' + tx(ev.title), 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar;charset=utf-8' }));
      a.download = (ev.file || 'calendar') + '.ics';
      document.body.appendChild(a); a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
    }
    function google(ev) {
      const end = ev.end && ev.end > ev.start ? ev.end : ev.start + 3600e3;
      return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(ev.title || '')
        + '&dates=' + z(ev.start) + '/' + z(end)
        + '&details=' + encodeURIComponent([ev.details, ev.url].filter(Boolean).join('\n\n'));
    }
    function close(refocus) {
      if (!pop) return;
      pop.remove(); pop = null;
      removeEventListener('pointerdown', outside, true); removeEventListener('keydown', key, true);
      removeEventListener('scroll', shut, true); removeEventListener('resize', shut);
      if (owner) { owner.setAttribute('aria-expanded', 'false'); if (refocus) owner.focus(); owner = null; }
    }
    const shut = () => close(false);
    const outside = (e) => { if (pop && !pop.contains(e.target) && !owner.contains(e.target)) close(false); };
    const key = (e) => {
      if (!pop) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const items = [...pop.querySelectorAll('a,button')], i = items.indexOf(document.activeElement);
        e.preventDefault(); items[(i + (e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length].focus();
      }
    };
    function menu(btn, ev) {
      if (!ev || !ev.start) return;
      if (pop && owner === btn) { close(true); return; }
      close(false); style();
      pop = document.createElement('div'); pop.className = 's26cal'; pop.setAttribute('role', 'menu');
      const g = document.createElement('a'); g.setAttribute('role', 'menuitem');
      g.href = google(ev); g.target = '_blank'; g.rel = 'noopener';
      g.innerHTML = ICON_G + '<span>Google Calendar</span>';
      const f = document.createElement('button'); f.type = 'button'; f.setAttribute('role', 'menuitem');
      f.innerHTML = ICON_F + '<span>Apple / Outlook</span><small>.ics</small>';
      g.addEventListener('click', () => close(false));
      f.addEventListener('click', () => { ics(ev); close(true); });
      pop.append(g, f);
      /* inside a dialog the menu has to live in the dialog, or it renders underneath it */
      (btn.closest('dialog') || document.body).appendChild(pop);
      owner = btn; btn.setAttribute('aria-haspopup', 'menu'); btn.setAttribute('aria-expanded', 'true');
      const r = btn.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight, vw = innerWidth, vh = innerHeight;
      const left = Math.max(8, Math.min(r.left, vw - w - 8));
      const top = r.bottom + 8 + h <= vh - 8 ? r.bottom + 8 : Math.max(8, r.top - h - 8);
      pop.style.left = left + 'px'; pop.style.top = top + 'px';
      g.focus({ preventScroll: true });
      setTimeout(() => {
        addEventListener('pointerdown', outside, true); addEventListener('keydown', key, true);
        addEventListener('scroll', shut, { capture: true, passive: true }); addEventListener('resize', shut);
      });
    }
    return { menu, ics, google };
  })();

  /* ---------- phases + countdown ---------- */
  const roots = new Set();
  /* Why so careful about touching the DOM: the store runs a translation app (Transcy) whose
     MutationObserver re-scans the page on every DOM change. Anything that mutates per frame
     or per second — creating nodes, re-setting an attribute to the value it already has,
     writing inline styles on pointermove — turns into a full-page scan, and on a slower PC
     that is what made scrolling stall. So: build nodes once, change only what really changed,
     and drive pointer effects through a stylesheet rule (CSSOM edits are not DOM mutations). */
  const setText = (el, v) => { if (el && el.textContent !== v) el.textContent = v; };
  const setHidden = (el, h) => { if (el && el.hidden !== h) el.hidden = h; };
  function roll(n, v) {
    if (n._v === v) return;
    const first = n._v === undefined;
    n._v = v;
    if (!n._a) {
      n.textContent = '';
      n._a = document.createElement('i'); n._b = document.createElement('i');
      n._a.textContent = v; n._b.textContent = v; n._b.className = 'is-ghost';
      n.append(n._a, n._b);
      return;
    }
    /* the seconds just change: a fade-in every second dipped the digit to nothing each tick, which
       read as a flicker */
    if (first || reduced || !n._a.animate || n.dataset.u === 's') { n._a.firstChild.nodeValue = v; return; }
    n._b.firstChild.nodeValue = n._a.firstChild.nodeValue;
    n._a.firstChild.nodeValue = v;
    /* minutes and up cross-fade, the old value out as the new one comes in, so the digit never goes blank */
    const o = { duration: 350, easing: 'ease-out' };
    if (n._aa) { n._aa.cancel(); n._ab.cancel(); }
    n._aa = n._a.animate([{ opacity: 0 }, { opacity: 1 }], o);
    n._ab = n._b.animate([{ opacity: 1 }, { opacity: 0 }], o);
  }
  function tickRoot(root) {
    const now = nowMs();
    const t1 = ts(root.dataset.t1), t1b = ts(root.dataset.t1b), t2 = ts(root.dataset.t2), t3 = ts(root.dataset.t3);
    let phase = 'warmup', target = t1, label = root.dataset.l0;
    /* optional stage before the first: [data-t0] counts to when something opens (the Reservation Card
       goes on sale) with its own label, instead of counting to its close before it has even opened */
    const t0 = ts(root.dataset.t0);
    if (t0 && now < t0) { target = t0; label = root.dataset.lpre || label; }
    if (t1 && now >= t1) { target = t2; label = root.dataset.l1; }
    /* the day between pre-sale closing and the main sale opening */
    if (t1b && t2 && now >= t1b && now < t2) phase = 'gap';
    if (t2 && now >= t2) { phase = 'sale'; target = t3; label = root.dataset.l2; }
    if (t3 && now >= t3) { phase = 'ended'; target = null; }
    if (root.dataset.phase !== phase) {
      root.dataset.phase = phase;
      root.querySelectorAll('[data-show]').forEach((el) => { el.hidden = !el.dataset.show.split(' ').includes(phase); });
      root.querySelectorAll('.s26-pill').forEach((p) => p.classList.toggle('is-live', phase === 'sale'));
    }
    const bar = root.querySelector('[data-s26-progress]');
    if (bar && t1 && t3) { const v = Math.min(1, Math.max(0, (now - t1) / (t3 - t1))).toFixed(3); if (bar._p !== v) { bar._p = v; bar.style.setProperty('--p', v); } }
    const clock = root.querySelector('[data-s26-clock]');
    if (!clock) return;
    const wrap = clock.closest('[data-s26-clock-wrap]') || clock;
    if (!target) { setHidden(wrap, true); return; }
    setHidden(wrap, false);
    const lab = root.querySelector('[data-s26-clock-label]');
    if (label) setText(lab, label);
    const s = Math.max(0, Math.floor((target - now) / 1000));
    const set = (u, v) => { const n = clock.querySelector('[data-u="' + u + '"]'); if (n) roll(n, pad(v)); };
    set('d', Math.floor(s / 86400)); set('h', Math.floor(s / 3600) % 24); set('m', Math.floor(s / 60) % 60); set('s', s % 60);
  }
  /* ---------- time gates: [data-s26-after] shows from that GMT+8 moment, [data-s26-before] until it ----------
     A class, not [hidden], so it never fights the phase toggles above on the same element. The markup
     ships in the "not yet" state, so nothing is clickable early if this never runs. */
  function tickGates(scope) {
    const now = nowMs();
    (scope || document).querySelectorAll('[data-s26-after], [data-s26-before]').forEach((el) => {
      const a = ts(el.dataset.s26After), b = ts(el.dataset.s26Before);
      const on = (!a || now >= a) && (!b || now < b);
      if (el._gate !== on) { el._gate = on; el.classList.toggle('s26-gate-off', !on); }
    });
  }
  setInterval(() => { roots.forEach(tickRoot); tickGates(); }, 1000);

  /* ---------- reveal ---------- */
  /* cards from the reused bts-* sections join in on this page only; their own files are untouched */
  const AUTO = '.btt__row, .btr__step, .bgv__prize, .dq__item, .bts-dealtabs .m-thc-card, .m11-bundles .m-th-bg__card, .sof__card, .sof__perk';
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    let i = 0;
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      io.unobserve(el);
      if (el.classList.contains('s26-split')) { el.classList.add('is-in'); return; }
      const d = Math.min(i++, 6) * 80;
      el.style.setProperty('--s26-d', d + 'ms');
      el.classList.add('is-in');
      /* once it has arrived, hand transform back to the card's own hover lift */
      setTimeout(() => { el.classList.remove('s26-r', 'is-in'); el.style.removeProperty('--s26-d'); }, d + 1000);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function splitWords(el) {
    if (el.dataset.s26Split === 'done') return;
    el.dataset.s26Split = 'done';
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((c) => {
        if (c.nodeType === 3) {
          const frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const w = document.createElement('span'); w.className = 's26-w';
            const inner = document.createElement('span'); inner.textContent = part; inner.style.setProperty('--i', i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          c.replaceWith(frag);
        } else if (c.nodeType === 1 && c.tagName !== 'BR') walk(c);
      });
    };
    walk(el);
    el.classList.add('s26-split');
  }

  /* ---------- pointer: hero depth, magnet ---------- */
  let pointerBound = false;
  function bindPointer() {
    if (pointerBound || !fine.matches) return;
    pointerBound = true;
    const dyn = document.createElement('style');
    document.head.appendChild(dyn);
    const rule = (sel) => dyn.sheet.cssRules[dyn.sheet.insertRule(sel + '{}', dyn.sheet.cssRules.length)].style;
    const rHero = rule('[data-s26-hero]'), rMag = rule('[data-s26-mag]');
    let mag = null, ev = null, queued = false;
    const flip = (cur, next, attr) => { if (cur === next) return cur; if (cur) cur.removeAttribute(attr); if (next) next.setAttribute(attr, ''); return next; };
    const frame = () => {
      queued = false;
      const e = ev, t = e.target instanceof Element ? e.target : null;
      if (reduced) return;
      const hero = t && t.closest('[data-s26-hero]');
      if (hero) { const r = hero.getBoundingClientRect(); rHero.setProperty('--px', ((e.clientX - r.left) / r.width - .5).toFixed(3)); rHero.setProperty('--py', ((e.clientY - r.top) / r.height - .5).toFixed(3)); }
      else { rHero.setProperty('--px', '0'); rHero.setProperty('--py', '0'); }
      const m = t && t.closest('[data-s26-magnet]');
      mag = flip(mag, m, 'data-s26-mag');
      if (m) { const r = m.getBoundingClientRect(); rMag.setProperty('translate', Math.max(-8, Math.min(8, (e.clientX - r.left - r.width / 2) * .22)) + 'px ' + Math.max(-6, Math.min(6, (e.clientY - r.top - r.height / 2) * .3)) + 'px'); }
    };
    document.addEventListener('pointermove', (e) => { ev = e; if (!queued) { queued = true; requestAnimationFrame(frame); } }, { passive: true });
    document.addEventListener('pointerleave', () => { mag = flip(mag, null, 'data-s26-mag'); rHero.setProperty('--px', '0'); rHero.setProperty('--py', '0'); });
  }

  /* ---------- pause looping animations while their section is off screen ----------
     The marquee used to speed up with scroll by rewriting each animation's playbackRate every
     frame. Every write pulls the animation off the compositor and back through the main
     thread — which is exactly the thread a scroll keeps busy — so on slower PCs the marquee
     stalled mid-scroll. Now every loop is a plain CSS animation the compositor runs alone, and
     sections that are off screen simply pause (.s26-off). */
  const marquees = new Set();
  const offIO = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle('s26-off', !e.isIntersecting)), { rootMargin: '200px 0px' }) : null;
  const LOOPERS = '.s26-mq, .s26-hero, .s26bo, .sof--ticket, .s26g';


  /* ---------- numbers that count to their new value ---------- */
  const money = (v) => '$' + (Math.round(v * 100) % 100 ? v.toFixed(2) : Math.round(v).toLocaleString('en-US'));
  function countTo(el, to, fmt) {
    if (!el) return;
    const from = parseFloat(el.dataset.n || '0');
    el.dataset.n = to;
    if (reduced || from === to) { el.textContent = fmt(to); return; }
    const t0 = performance.now(), dur = 520;
    cancelAnimationFrame(el._raf);
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (to - from) * e);
      if (k < 1) el._raf = requestAnimationFrame(step);
    };
    el._raf = requestAnimationFrame(step);
  }
  const cartRoot = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  /* drawer: open the cart drawer after adding, as the $1 Reservation Card page does (KOR order limits
     run at the cart's checkout button); /cart when the drawer is turned off */
  function openCart() {
    if (document.querySelector('m-cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    else location.href = cartRoot() + 'cart';
  }
  function addToCart(ids, btn, fallbackUrl, drawer) {
    if (!ids.length) return;
    btn.setAttribute('aria-busy', 'true');
    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
    }).then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (ok && drawer) { btn.removeAttribute('aria-busy'); openCart(); return; }
        if (ok) { location.href = cartRoot() + 'cart'; return; }
        btn.removeAttribute('aria-busy');
        const msg = btn.closest('[data-s26-boost], [data-s26-bundle]')?.querySelector('[data-bo-msg], [data-bd-msg]');
        if (msg) { msg.textContent = j.description || j.message || 'Could not add to cart.'; msg.hidden = false; }
      })
      .catch(() => { btn.removeAttribute('aria-busy'); if (fallbackUrl) location.href = fallbackUrl; });
  }

  /* ---------- Spend & Save calculator ----------
     The tiers are a row of keys with the cart slider under them; each threshold sits under the
     centre of its key. Passing a threshold presses that key (GSAP, short one-off tweens only:
     the translation app re-scans the page on DOM changes, so nothing here loops). */
  function initSpend(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    let tiers = [], T = {};
    try { tiers = JSON.parse(root.dataset.tiers || '[]').sort((a, b) => a.min - b.min); } catch (e) {}
    try { T = JSON.parse((root.querySelector('[data-sp-t]') || {}).textContent || '{}'); } catch (e) {}
    if (!tiers.length) return;
    const n = tiers.length, last = tiers[n - 1].min;
    const max = Math.max(parseFloat(root.dataset.max) || 0, last * 1.25);
    /* half a key before the first tier, a whole key between tiers, half a key after the last */
    const A = [0].concat(tiers.map((x) => x.min), [max]);
    const F = [0].concat(tiers.map((x, i) => (i + .5) / n), [1]);
    const P = 1000, S = A.length - 2;
    const amtAt = (p) => { const f = p / P; let i = 0; while (i < S && f >= F[i + 1]) i++; return A[i] + (A[i + 1] - A[i]) * (f - F[i]) / ((F[i + 1] - F[i]) || 1); };
    const posAt = (v) => { if (v >= max) return P; let i = 0; while (i < S && v >= A[i + 1]) i++; return (F[i] + (F[i + 1] - F[i]) * (v - A[i]) / ((A[i + 1] - A[i]) || 1)) * P; };
    const esc = (x) => String(x).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const fill = (str, o, bold) => esc(str || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? (bold ? '<b>' + esc(o[k]) + '</b>' : o[k]) : m));
    const setHTML = (el, h) => { if (el && el._h !== h) { el._h = h; el.innerHTML = h; } };
    const q = (k) => root.querySelector('[data-sp-' + k + ']');
    const range = q('range'), amount = q('amount'), saveEl = q('save'), payEl = q('pay'), sub = q('sub'), live = q('live');
    const next = q('next'), nextText = q('next-text');
    const stops = [...root.querySelectorAll('[data-sp-stop]')], keys = [...root.querySelectorAll('[data-sp-tier]')];
    if (!root.id) root.id = 's26sp-' + Math.random().toString(36).slice(2);
    const st = document.createElement('style'); document.head.appendChild(st);
    const vars = st.sheet.cssRules[st.sheet.insertRule('#' + CSS.escape(root.id) + '{--v:0;--g:0}', 0)].style;

    let G = null;
    const warm = () => loadGsap(root.dataset.gsapSrc).then((g) => { G = g; return g; });
    if ('IntersectionObserver' in window) {
      const w = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { w.disconnect(); warm(); } }, { rootMargin: '600px 0px' });
      w.observe(root);
    } else warm();
    /* a key going down and springing back, like a keystroke */
    const press = (k) => {
      const el = k.querySelector('[data-sp-press]');
      if (!G || reduced || !el) return;
      G.timeline({ onComplete: () => G.set(el, { clearProps: 'transform' }) })
        .to(el, { y: 5, duration: .07, ease: 'power2.out', overwrite: true })
        .to(el, { y: 0, duration: .36, ease: 'back.out(2.4)' });
    };
    const fitAmount = () => { if (!amount) return; const len = Math.max(1, String(amount.value).length); if (amount._len !== len) { amount._len = len; amount.style.width = (len + .2) + 'ch'; } };

    let V = -1, tierKey = null, lastSave = null;
    function render(v, from, pos) {
      v = Math.round(Math.max(0, Math.min(max * 4, v || 0)));
      if (pos == null) pos = posAt(v);
      vars.setProperty('--v', (pos / P).toFixed(4));
      if (range && from !== 'range' && +range.value !== Math.round(pos)) range.value = Math.round(pos);
      if (v === V) return; V = v;
      if (amount && from !== 'amount' && +amount.value !== v) amount.value = v;
      fitAmount();
      if (range) range.setAttribute('aria-valuetext', money(v));
      const t = tiers.filter((x) => v >= x.min).pop();
      const save = t ? t.save : 0, pay = Math.max(0, v - save), nt = tiers.find((x) => v < x.min);
      stops.forEach((s) => { const on = v >= +s.dataset.min; if (s._on !== on) { s._on = on; s.classList.toggle('is-on', on); } });
      keys.forEach((k) => {
        const m = +k.dataset.min, on = v >= m, cur = String(!!t && m === t.min);
        if (k._on !== on) { const was = k._on; k._on = on; k.classList.toggle('is-on', on); if (on && was === false) press(k); }
        if (k.getAttribute('aria-pressed') !== cur) k.setAttribute('aria-pressed', cur);
      });
      if (save !== lastSave) { root.classList.toggle('is-saving', save > 0); countTo(saveEl, save, money); lastSave = save; }
      setText(payEl, money(pay));
      setHTML(sub, save > 0 && T.pct ? fill(T.pct, { pct: (save / v * 100).toFixed(1) }) : esc(T.none || ''));
      if (next) {
        if (next._top !== !nt) { next._top = !nt; next.classList.toggle('is-top', !nt); }
        if (nt) {
          const prev = t ? t.min : 0;
          setHTML(nextText, fill(T.next, { amount: money(nt.min - v), save: money(nt.save) }, true));
          vars.setProperty('--g', ((v - prev) / (nt.min - prev)).toFixed(4));
        } else setHTML(nextText, esc(T.top || ''));
      }
      const key = t ? t.min : -1;
      if (key !== tierKey) { const first = tierKey === null; tierKey = key; if (!first && live) setText(live, fill(T.live, { save: money(save), pay: money(pay) })); }
    }

    let demoRaf = 0, glide = null;
    const stop = () => { cancelAnimationFrame(demoRaf); demoRaf = 0; if (glide) { glide.kill(); glide = null; } };
    if (range) range.addEventListener('input', () => { stop(); const p = +range.value; render(amtAt(p), 'range', p); });
    if (amount) amount.addEventListener('input', () => { stop(); render(parseFloat(amount.value), 'amount'); });
    /* a tapped key glides the cart there; from the keyboard it jumps (no motion on key presses) */
    keys.forEach((k) => k.addEventListener('click', (e) => {
      stop();
      const to = +k.dataset.min;
      if (!G || reduced || e.detail === 0) { render(to); return; }
      const o = { p: posAt(V < 0 ? 0 : V) };
      glide = G.to(o, { p: posAt(to), duration: .5, ease: 'power3.inOut', onUpdate: () => render(amtAt(o.p), null, o.p), onComplete: () => { glide = null; render(to); } });
    }));
    const start = parseFloat(root.dataset.start) || tiers[0].min;
    render(0);
    /* a short demo when it scrolls into view, so it reads as something you can drag */
    const demo = () => {
      if (reduced) { render(start); return; }
      const t0 = performance.now(), dur = 1500, to = posAt(start);
      const step = (t) => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3), p = to * e; render(k < 1 ? amtAt(p) : start, null, k < 1 ? p : null); demoRaf = k < 1 ? requestAnimationFrame(step) : 0; };
      demoRaf = requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      const o = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { o.disconnect(); warm().then(demo); } }, { threshold: .35 });
      o.observe(root);
    } else render(start);
  }

  /* ---------- Credit Boost builder ---------- */
  function initBoost(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    const d = root.dataset;
    const T = { 1: { pay: +d.p1, get: +d.g1, id: d.v1 || '' }, 2: { pay: +d.p2, get: +d.g2, id: d.v2 || '' } };
    const picks = [...root.querySelectorAll('[data-bo-pick]')], cards = [...root.querySelectorAll('[data-bo-card]')];
    const q = (k) => root.querySelector('[data-bo-' + k + ']');
    const buy = q('buy'), buyLabel = q('buy-label');
    let pick = d.pick || '2';
    const chosen = () => (pick === 'both' ? [T[1], T[2]] : [T[pick]]);
    function phase() {
      const now = nowMs(), a = ts(d.from), b = ts(d.to);
      if (a && now < a) return 'soon';
      if (b && now >= b) return 'done';
      return 'live';
    }
    function render() {
      const c = chosen();
      const pay = c.reduce((n, x) => n + x.pay, 0), get = c.reduce((n, x) => n + x.get, 0);
      picks.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.boPick === pick)));
      cards.forEach((el) => el.classList.toggle('is-picked', pick === 'both' || el.dataset.boCard === pick));
      root.dataset.picked = pick;
      countTo(q('pay'), pay, money);
      countTo(q('get'), get, money);
      countTo(q('bonus'), get - pay, (x) => '+' + money(x));
      const pct = q('pct'); if (pct) pct.textContent = ((get - pay) / get * 100).toFixed(1) + '%';
      const bar = q('bar'); if (bar) bar.style.setProperty('--paid', (pay / get).toFixed(4));
      const ph = phase();
      root.dataset.boPhase = ph;
      const now = nowMs();
      let next = false;
      root.querySelectorAll('[data-bo-step]').forEach((st) => {
        const a = ts(st.dataset.from), b = ts(st.dataset.to);
        const on = !!(a && now >= a && (!b || now < b)), done = !!(b && now >= b);
        const nx = !on && !done && !next && !!a && now < a;
        if (on || nx) next = true;
        st.classList.toggle('is-now', on);
        st.classList.toggle('is-done', done);
        st.classList.toggle('is-next', nx);
      });
      if (buy) {
        const ids = c.map((x) => x.id).filter(Boolean);
        const missing = ids.length !== c.length;
        buy.disabled = ph !== 'live' || missing;
        if (buyLabel) buyLabel.textContent =
          ph === 'soon' ? d.lSoon : ph === 'done' ? d.lDone : missing ? d.lSoldout :
          (pick === 'both' ? d.lBoth : d.lBuy).replace('[pay]', money(pay));
      }
    }
    picks.forEach((p) => p.addEventListener('click', () => { pick = p.dataset.boPick; render(); }));
    cards.forEach((el) => el.addEventListener('click', () => { pick = el.dataset.boCard; render(); }));
    if (buy) buy.addEventListener('click', () => { if (!buy.disabled) addToCart(chosen().map((x) => x.id).filter(Boolean), buy, null, true); });
    render();
    setInterval(render, 30000);

    /* the cards lean toward the pointer and the foil follows it */
    const stage = q('stage');
    if (stage && fine.matches && !reduced) {
      let raf = 0, ev = null;
      const paint = () => {
        raf = 0;
        const r = stage.getBoundingClientRect(), px = (ev.clientX - r.left) / r.width - .5, py = (ev.clientY - r.top) / r.height - .5;
        const st = stage.style;
        st.setProperty('--ry', (px * 18).toFixed(2) + 'deg'); st.setProperty('--rx', (-py * 14).toFixed(2) + 'deg');
        st.setProperty('--fx', ((.5 - px) * 120 + 50).toFixed(1) + '%');
        st.setProperty('--mx', ((px + .5) * 100).toFixed(1) + '%'); st.setProperty('--my', ((py + .5) * 100).toFixed(1) + '%');
        st.setProperty('--sheen', Math.min(1, Math.hypot(px, py) * 1.6 + .25).toFixed(2));
      };
      stage.addEventListener('pointermove', (e) => { ev = e; if (!raf) raf = requestAnimationFrame(paint); });
      stage.addEventListener('pointerleave', () => {
        ['--ry', '--rx'].forEach((k) => stage.style.setProperty(k, '0deg'));
        stage.style.removeProperty('--sheen');
      });
    }
    /* the cards rise onto the stage the first time it comes into view */
    if (stage) {
      if (reduced || !('IntersectionObserver' in window)) stage.classList.add('is-in');
      else {
        const io = new IntersectionObserver((es) => {
          if (es.some((x) => x.isIntersecting)) { stage.classList.add('is-in'); io.disconnect(); }
        }, { threshold: .35 });
        io.observe(stage);
      }
    }
  }


  /* ---------- campaign calendar ---------- */
  const DAY = 864e5, MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'], DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  const dUTC = (str) => { const m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(String(str || '').trim()); return m ? Date.UTC(+m[1], m[2] - 1, +m[3]) : null; };
  /* an activity's first / last moment in real time: "YYYY-MM-DD HH:MM" is that minute (GMT+8);
     a bare date means the start / the end of that GMT+8 day */
  const hasTime = (v) => /\d{1,2}:\d{2}/.test(String(v || ''));
  const startMs = (v) => (hasTime(v) ? ts(v) : dUTC(v) == null ? null : dUTC(v) - 8 * 3600e3);
  const endMs = (v) => (hasTime(v) ? ts(v) : dUTC(v) == null ? null : dUTC(v) + DAY - 8 * 3600e3);
  const fmtDay = (t) => { const d = new Date(t); return MON[d.getUTCMonth()] + ' ' + d.getUTCDate(); };
  const span = (a, b) => (a === b ? fmtDay(a) : fmtDay(a) + ' – ' + fmtDay(b));
  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };

  function initCalendar(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    let data;
    try { data = JSON.parse(root.querySelector('[data-cal-data]').textContent); } catch (e) { return; }
    const start = dUTC(root.dataset.start), end = dUTC(root.dataset.end);
    if (start == null || end == null || end < start) return;
    const nWeeks = Math.ceil((Math.round((end - start) / DAY) + 1) / 7);
    /* "today" is the calendar day in GMT+8, the campaign's own clock */
    const today = dUTC(new Date(nowMs() + 8 * 3600e3).toISOString().slice(0, 10));
    const L = data.labels || {};
    const evs = (data.events || []).map((e, i) => ({ ...e, i, a: dUTC(e.from), b: dUTC(e.to || e.from) }))
      .filter((e) => e.a != null && e.b != null && e.b >= e.a);
    const tNow = nowMs();
    evs.forEach((e) => { e.state = tNow >= endMs(e.to || e.from) ? 'done' : tNow < startMs(e.from) ? 'soon' : 'live'; });
    const marks = {};
    (data.marks || []).forEach((m) => { const t = dUTC(m.date); if (t != null) marks[t] = m; });

    /* one lane per activity for the whole run, so a bar keeps its row week to week;
       each week then drops the lanes it doesn't use */
    const lanes = [];
    [...evs].sort((x, y) => x.a - y.a || (y.b - y.a) - (x.b - x.a) || x.i - y.i).forEach((e) => {
      let n = lanes.findIndex((occ) => occ.every((o) => e.b < o.a || e.a > o.b));
      if (n < 0) { n = lanes.length; lanes.push([]); }
      lanes[n].push(e); e.lane = n;
    });

    const board = root.querySelector('[data-cal-board]');
    board.innerHTML = '';
    const dow = el('div', 's26cal__dow');
    for (let d = 0; d < 7; d++) dow.appendChild(el('span', '', DOW[new Date(start + d * DAY).getUTCDay()]));
    board.appendChild(dow);
    let k = 0;
    for (let w = 0; w < nWeeks; w++) {
      const ws = start + w * 7 * DAY, we = Math.min(end, ws + 6 * DAY);
      const week = el('div', 's26cal__week'), days = el('div', 's26cal__days'), lanesEl = el('div', 's26cal__lanes');
      for (let d = 0; d < 7; d++) {
        const t = ws + d * DAY, cell = el('div', 's26cal__day');
        if (t > end) { cell.classList.add('is-out'); days.appendChild(cell); continue; }
        cell.textContent = new Date(t).getUTCDate();
        const m = marks[t];
        if (m) { cell.classList.add('has-mark'); cell.title = m.label; if (m.big) cell.classList.add('is-big'); }
        if (t < today) cell.classList.add('is-past');
        if (t === today) cell.classList.add('is-today');
        days.appendChild(cell);
      }
      const segs = evs.filter((e) => e.a <= we && e.b >= ws);
      const used = [...new Set(segs.map((e) => e.lane))].sort((x, y) => x - y);
      segs.forEach((e) => {
        const s0 = Math.max(e.a, ws), s1 = Math.min(e.b, we);
        const bar = el('button', 's26cal__bar c-' + (e.color || 'blue') + ' is-' + e.state);
        bar.type = 'button';
        bar.dataset.ev = e.i;
        bar.style.gridColumn = (Math.round((s0 - ws) / DAY) + 1) + ' / ' + (Math.round((s1 - ws) / DAY) + 2);
        bar.style.gridRow = String(used.indexOf(e.lane) + 1);
        bar.style.setProperty('--k', k++);
        if (e.a < ws) bar.classList.add('is-cont-l');
        if (e.b > we) bar.classList.add('is-cont-r');
        bar.setAttribute('aria-label', e.title + ', ' + span(e.a, e.b));
        bar.appendChild(el('span', '', e.short || e.title));
        lanesEl.appendChild(bar);
      });
      week.appendChild(days);
      if (segs.length) week.appendChild(lanesEl);
      board.appendChild(week);
    }

    /* the list: state chips, and picking keeps grid and list in step */
    const rows = [...root.querySelectorAll('[data-cal-row]')];
    rows.forEach((r) => {
      const e = evs.find((x) => x.i === +r.dataset.calRow); if (!e) return;
      r.dataset.state = e.state;
      const chip = r.querySelector('[data-cal-state]'); if (chip) chip.textContent = L[e.state] || '';
    });
    let picked = null;
    function pick(i) {
      picked = picked === i ? null : i;
      root.classList.toggle('has-pick', picked !== null);
      board.querySelectorAll('.s26cal__bar').forEach((b) => b.classList.toggle('is-picked', +b.dataset.ev === picked));
      rows.forEach((r) => {
        const on = +r.dataset.calRow === picked;
        r.classList.toggle('is-open', on);
        const more = r.querySelector('.s26cal__more'); if (more) more.hidden = !on;
        const btn = r.querySelector('.s26cal__row-btn'); if (btn) btn.setAttribute('aria-expanded', String(on));
      });
    }
    board.addEventListener('click', (ev) => {
      const b = ev.target.closest('.s26cal__bar'); if (!b) return;
      pick(+b.dataset.ev);
      const r = rows.find((x) => +x.dataset.calRow === picked);
      if (r && matchMedia('(max-width: 899px)').matches) r.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
    });
    rows.forEach((r) => r.querySelector('.s26cal__row-btn')?.addEventListener('click', () => pick(+r.dataset.calRow)));

    const tl = root.querySelector('[data-cal-today]');
    if (tl) {
      if (today < start) tl.textContent = L.before || '';
      else if (today > end) tl.textContent = L.after || '';
      else { tl.textContent = (L.today || 'Today') + ' · ' + DOW[new Date(today).getUTCDay()] + ' ' + fmtDay(today); tl.classList.add('is-on'); }
    }
  }

  /* ---------- timeline: row states and the today line ---------- */
  /* mouse drag for a sideways-scrolling row; touch and trackpads keep their native scrolling */
  function dragRow(row, h) {
    let d = null, block = false;
    row.addEventListener('dragstart', (e) => e.preventDefault());
    row.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      d = { x: e.clientX, base: row.scrollLeft, moved: false, lx: e.clientX, lt: performance.now(), vx: 0, id: e.pointerId };
    });
    row.addEventListener('pointermove', (e) => {
      if (!d || e.pointerId !== d.id) return;
      const dx = e.clientX - d.x;
      if (!d.moved) {
        if (Math.abs(dx) < 6) return;
        d.moved = true; row.classList.add('is-dragging');
        try { row.setPointerCapture(e.pointerId); } catch (_) {}
        if (h.start) h.start();
      }
      const want = d.base - dx, got = h.move(want);
      d.base += got - want; /* keep following the pointer after wrapping past the seam */
      const t = performance.now(), dt = t - d.lt;
      if (dt > 0) { d.vx = d.vx * 0.6 + ((e.clientX - d.lx) / dt) * 1000 * 0.4; d.lx = e.clientX; d.lt = t; }
    });
    const up = (e) => {
      if (!d || e.pointerId !== d.id) return;
      const moved = d.moved, vx = performance.now() - d.lt > 120 ? 0 : d.vx;
      d = null; row.classList.remove('is-dragging');
      if (moved) { block = true; setTimeout(() => { block = false; }, 0); if (h.end) h.end(vx); }
    };
    row.addEventListener('pointerup', up);
    row.addEventListener('pointercancel', up);
    row.addEventListener('click', (e) => { if (block) { e.preventDefault(); e.stopPropagation(); block = false; } }, true);
  }

  function initTimeline(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    let L = {};
    try { L = JSON.parse(root.querySelector('[data-tl-labels]').textContent); } catch (e) {}
    const start = dUTC(root.dataset.from), end = dUTC(root.dataset.to);
    const rowsEl = root.querySelector('.s26tl__rows'), now = root.querySelector('[data-tl-now]');
    function paint() {
      const t = nowMs();
      root.querySelectorAll(':is(.s26tl__row, .s26tl__card)[data-from]').forEach((r) => {
        const a = ts(r.dataset.from), b = ts(r.dataset.to);
        const st = b && t > b ? 'done' : a && t < a ? 'soon' : 'live';
        if (r.dataset.state !== st) r.dataset.state = st;
        const chip = r.querySelector('[data-tl-state]'); if (chip && chip.textContent !== (L[st] || '')) chip.textContent = L[st] || '';
      });
      /* GMT+8 calendar day and how far through it we are */
      const g = t + 8 * 3600e3, day = Math.floor(g / DAY) * DAY, frac = (g - day) / DAY;
      /* key dates: past ones fade, today is filled, the next one is outlined */
      let nextSet = false;
      root.querySelectorAll('.s26tl__date[data-date]').forEach((d) => {
        const v = dUTC(d.dataset.date), isToday = v === day, past = v < day, next = !nextSet && v > day;
        if (next) nextSet = true;
        d.classList.toggle('is-today', isToday); d.classList.toggle('is-past', past); d.classList.toggle('is-next', next);
        const f = isToday ? L.today : next ? L.next : '';
        if (f) { if (d.dataset.flag !== f) d.dataset.flag = f; } else if (d.hasAttribute('data-flag')) d.removeAttribute('data-flag');
      });
      root.querySelectorAll('.s26tl__tick').forEach((k) => k.classList.toggle('is-today', dUTC(k.dataset.date) === day));
      const track = root.querySelector('.s26tl__track');
      if (!now || !track || start == null || end == null || day < start || day > end) { if (now) now.hidden = true; return; }
      const span = Math.round((end - start) / DAY) + 1;
      const tr = track.getBoundingClientRect(), rr = rowsEl.getBoundingClientRect();
      if (!tr.width) { now.hidden = true; return; }
      now.style.left = (tr.left - rr.left + tr.width * ((day - start) / DAY + frac) / span).toFixed(1) + 'px';
      now.hidden = false;
    }
    paint();
    setInterval(paint, 60000);
    addEventListener('resize', paint, { passive: true });

    /* cards style: one row that keeps scrolling (clones wrap it; slows to a stop under the mouse,
       on keyboard focus and after a touch; only while on screen; none under reduced motion) */
    const cards = [...root.querySelectorAll('.s26tl__card[data-phase]')];
    const row = root.querySelector('[data-tl-loop]');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let rebuildLoop = () => {};
    if (row && cards.length && !reduce && !window.Shopify?.designMode) {
      const speed = +row.dataset.tlLoop || 30;
      let loopW = 0, pos = 0, set = -1, v = 0, last = 0, raf = 0, onScreen = false, hover = false, focus = false, holdUntil = 0, dragging = false;
      rebuildLoop = () => {
        row.querySelectorAll('[data-tl-clone]').forEach((c) => c.remove());
        const vis = cards.filter((c) => !c.hidden);
        row.classList.remove('is-looping'); loopW = 0;
        if (!vis.length || row.scrollWidth <= row.clientWidth + 2) { row.scrollLeft = 0; pos = 0; return; }
        const first = vis[0].offsetLeft, gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        const end = vis[vis.length - 1].offsetLeft + vis[vis.length - 1].offsetWidth + gap;
        loopW = end - first;
        let filled = 0;
        while (filled < row.clientWidth + loopW * 0.1) {
          vis.forEach((c) => {
            const k = c.cloneNode(true);
            k.dataset.tlClone = ''; k.setAttribute('aria-hidden', 'true'); k.removeAttribute('data-shopify-editor-block');
            k.querySelectorAll('a, button').forEach((a) => a.setAttribute('tabindex', '-1'));
            row.append(k);
          });
          filled += loopW;
        }
        row.classList.add('is-looping');
        pos = row.scrollLeft % loopW; set = -1;
      };
      const step = (now) => {
        raf = 0;
        const dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
        /* under the mouse it only slows down (stopping read as broken); a drag, focus or touch holds it */
        const want = dragging || focus || now < holdUntil || document.hidden ? 0 : hover ? speed * 0.3 : speed;
        v += (want - v) * (1 - Math.exp(-dt / 0.45));
        if (loopW) {
          if (Math.abs(row.scrollLeft - set) > 2 && set !== -1) pos = row.scrollLeft;
          pos += v * dt;
          if (pos >= loopW) pos -= loopW; else if (pos < 0) pos += loopW;
          row.scrollLeft = pos; set = row.scrollLeft;
        }
        if (onScreen) raf = requestAnimationFrame(step);
      };
      const run = () => { if (!raf && onScreen) { last = 0; raf = requestAnimationFrame(step); } };
      new IntersectionObserver((es) => { onScreen = es[0].isIntersecting; if (onScreen) run(); }, { rootMargin: '100px' }).observe(row);
      row.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
      row.addEventListener('pointerleave', () => { hover = false; });
      /* keyboard focus only: a mouse press also focuses the card link, and that used to stop the row for good */
      const kbFocus = () => !!row.querySelector(':focus-visible');
      row.addEventListener('focusin', () => { focus = kbFocus(); });
      row.addEventListener('focusout', () => { setTimeout(() => { focus = kbFocus(); }, 0); });
      const hold = (ms) => () => { holdUntil = performance.now() + ms; v = 0; };
      row.addEventListener('touchstart', hold(2500), { passive: true });
      row.addEventListener('touchmove', hold(2500), { passive: true });
      row.addEventListener('wheel', (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) hold(1500)(); }, { passive: true });
      /* drag with the mouse: the row follows the pointer across the clone seam, a flick carries on
         and eases out, then the scroll picks up again; a drag never counts as a click on a card */
      dragRow(row, {
        start: () => { dragging = true; v = 0; },
        move: (sl) => { if (loopW) { while (sl < 0) sl += loopW; while (sl >= loopW) sl -= loopW; } row.scrollLeft = sl; pos = row.scrollLeft; set = pos; return sl; },
        end: (vx) => { dragging = false; v = Math.max(-2400, Math.min(2400, -vx)); holdUntil = performance.now() + 1400; run(); },
      });
      let rw = 0;
      addEventListener('resize', () => { if (innerWidth !== rw) { rw = innerWidth; rebuildLoop(); } }, { passive: true });
      rw = innerWidth;
      rebuildLoop();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(rebuildLoop);
    }

    if (row && cards.length && (reduce || window.Shopify?.designMode)) dragRow(row, { move: (sl) => { row.scrollLeft = sl; return row.scrollLeft; } });

    /* cards style: phase filters (counts in the chips; key dates outside the phase dim) */
    const chips = [...root.querySelectorAll('[data-tl-filter]')];
    if (!chips.length || !cards.length) return;
    const ranges = {};
    cards.forEach((c) => {
      const p = c.dataset.phase, a = dUTC(c.dataset.from.slice(0, 10)), b = dUTC(c.dataset.to.slice(0, 10));
      const r = ranges[p] || (ranges[p] = { a: a, b: b, n: 0 });
      r.n++; if (a != null && a < r.a) r.a = a; if (b != null && b > r.b) r.b = b;
    });
    chips.forEach((ch) => {
      const k = ch.dataset.tlFilter, n = k === 'all' ? cards.length : (ranges[k] ? ranges[k].n : 0);
      if (!n) { ch.hidden = true; return; }
      const b = document.createElement('b'); b.textContent = n; ch.append(' ', b);
    });
    function pick(k) {
      chips.forEach((ch) => ch.setAttribute('aria-pressed', ch.dataset.tlFilter === k ? 'true' : 'false'));
      let i = 0;
      cards.forEach((c) => {
        const show = k === 'all' || c.dataset.phase === k;
        if (c.hidden !== !show) c.hidden = !show;
        if (show && !reduce) { c.classList.remove('is-in'); void c.offsetWidth; c.style.setProperty('--k', i); c.classList.add('is-in'); }
        if (show) i++;
      });
      const r = k === 'all' ? null : ranges[k];
      root.querySelectorAll('.s26tl__date[data-date]').forEach((d) => {
        const v = dUTC(d.dataset.date);
        d.classList.toggle('is-off', !!r && (v < r.a || v > r.b));
      });
      if (row) { row.scrollLeft = 0; rebuildLoop(); }
    }
    chips.forEach((ch) => ch.addEventListener('click', () => pick(ch.dataset.tlFilter)));
  }

  /* ---------- 11.11 guide: one question, three tools (saving · a product · a date) ----------
     The first answer opens its tool at once: the budget slider sweeps up and unlocks offers on
     the way, the search field takes focus, the next key day is selected. GSAP (bh-gsap.min.js)
     is loaded when the section nears the screen and only adds motion: without it, or under
     reduced motion, every tool works the same, instantly. */
  function loadGsap(src) {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (!src || reduced) return Promise.resolve(null);
    if (!loadGsap.p) loadGsap.p = new Promise((res) => {
      const sc = document.createElement('script');
      sc.src = src; sc.async = true;
      sc.onload = () => res(window.gsap || null); sc.onerror = () => res(null);
      document.head.appendChild(sc);
    });
    return loadGsap.p;
  }

  function initGuide(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    let data;
    try { data = JSON.parse(root.querySelector('[data-g-data]').textContent); } catch (e) { return; }
    const t = data.t || {}, items = data.items || {};
    const DAY = 864e5;
    const today = dUTC(new Date(nowMs() + 8 * 3600e3).toISOString().slice(0, 10));
    const isEnded = (k) => !!items[k] && endMs(items[k].to) != null && nowMs() >= endMs(items[k].to);
    /* the featured offer (Credit Boost) goes first and gets its badge + perks, until it ends */
    const isFeat = (k) => !!data.feat && k === data.feat && !isEnded(k);
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    /* setting text may bold a value with <b>; nothing else is let through */
    const rich = (s) => esc(s).replace(/&lt;(\/?)b&gt;/g, '<$1b>');
    /* activity notes may still carry tokens meant for other tools: drop those sentences */
    const note = (s) => String(s || '').split(/(?<=[.!?])\s+/).filter((x) => !/\[\w+\]/.test(x)).join(' ');
    const fill = (s, o) => String(s || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
    const num = (v, d) => { const n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, '')); return isNaN(n) ? d : n; };
    const usd = (n) => '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n)));
    const tiers = String(data.tiers || '').split(',')
      .map((p) => p.split(':').map((x) => num(x, NaN)))
      .filter((p) => p.length === 2 && !isNaN(p[0]) && !isNaN(p[1]))
      .map(([min, save]) => ({ min, save })).sort((a, b) => a.min - b.min);
    const lc = { min: num(data.lcMin, 150), pct: num(data.lcPct, 10), cap: num(data.lcCap, 100) };

    const app = root.querySelector('[data-g-app]'), stage = root.querySelector('[data-g-stage]');
    const tabs = [...root.querySelectorAll('[data-g-mode]')];
    const panels = {};
    root.querySelectorAll('[data-g-panel]').forEach((p) => { panels[p.dataset.gPanel] = p; });
    if (!app || !stage || !tabs.length) return;

    let G = null;
    const warm = () => loadGsap(root.dataset.gsapSrc).then((g) => { G = g; return g; });
    if ('IntersectionObserver' in window) {
      const w = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { w.disconnect(); warm(); } }, { rootMargin: '600px 0px' });
      w.observe(root);
    } else warm();

    /* ---- offer rows, shared by the saving and product tools ---- */
    const ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
    const ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
    function makeRow(k, plain) {
      const it = items[k]; if (!it) return null;
      const li = el('li', 's26g__row');
      li.innerHTML = '<span class="s26g__row-ic"></span><div><p class="s26g__row-t"></p><p class="s26g__row-v"></p></div>';
      const tt = li.querySelector('.s26g__row-t');
      tt.textContent = it.title;
      if (it.dates) tt.appendChild(el('small', '', it.dates));
      if (it.link) { const a = el('a', 's26g__row-go', t.go || 'Go'); a.href = it.link; li.appendChild(a); }
      if (!plain && isFeat(k)) {
        li.classList.add('is-feat');
        if (t.featBadge) tt.appendChild(el('span', 's26g__row-badge', t.featBadge));
        if (t.featPerks) { const pk = el('p', 's26g__row-pk'); pk.innerHTML = rich(t.featPerks); tt.parentNode.appendChild(pk); }
      }
      return li;
    }
    /* only touch what changed: the store's translation app re-scans the page on every mutation */
    function setRow(li, state, html) {
      if (isEnded(li._k)) { state = 'ended'; html = esc(t.ended); }
      const turnedOn = li._s === 'off' && state === 'on';
      if (li._s !== state) {
        li._s = state;
        li.classList.toggle('is-on', state === 'on');
        li.classList.toggle('is-off', state !== 'on');
        li.classList.toggle('is-ended', state === 'ended');
        li.querySelector('.s26g__row-ic').innerHTML = state === 'on' ? ICON_ON : ICON_OFF;
      }
      if (li._h !== html) { li._h = html; li.querySelector('.s26g__row-v').innerHTML = html; }
      if (turnedOn && G) {
        G.fromTo(li.querySelector('.s26g__row-ic'), { scale: .55 }, { scale: 1, duration: .5, ease: 'back.out(3)', overwrite: true });
        G.fromTo(li.querySelector('.s26g__row-t'), { x: -6 }, { x: 0, duration: .45, ease: 'power3.out', overwrite: true });
      }
    }
    function rowFor(k, list, plain) { const li = makeRow(k, plain); if (li) { li._k = k; list.appendChild(li); } return li; }
    function spendText(A) {
      let cur = null, next = null;
      tiers.forEach((x) => { if (A >= x.min) cur = x; else if (!next) next = x; });
      if (!cur) return next ? rich(fill(t.spendGap, { gap: usd(next.min - A), save: usd(next.save) })) : '';
      let s = fill(t.spend, { save: usd(cur.save) });
      if (next) s += fill(t.spendNext, { gap: usd(next.min - A), save: usd(next.save) });
      return rich(s);
    }

    /* ---- tool 1: saving — budget slider unlocks offers ---- */
    const save = (() => {
      const p = panels.save; if (!p) return null;
      const range = p.querySelector('[data-g-range]'), out = p.querySelector('[data-g-amt]');
      const list = p.querySelector('[data-g-rows]'), tickBox = p.querySelector('[data-g-ticks]');
      const max = num(data.max, 250);
      const ROWS = [
        { k: 'deals', need: 0, v: () => rich(t.deals) },
        { k: 'mystery', need: num(data.mysteryFrom, 7), v: () => rich(t.mystery) },
        { k: 'boost', need: 50, v: (A) => rich(A >= 150 ? t.passBoth : A >= 100 ? t.pass100 : t.pass50) },
        { k: 'spend', need: tiers.length ? tiers[0].min : 80, v: spendText },
        { k: 'lastcall', need: lc.min, v: (A) => rich(fill(t.lastcall, { back: usd(Math.min(A * lc.pct / 100, lc.cap)) })) }
      ].filter((r) => items[r.k]).sort((a, b) => (isFeat(b.k) - isFeat(a.k)) || a.need - b.need);
      ROWS.forEach((r) => { r.li = rowFor(r.k, list); });
      const marks = [...new Set([50, ...tiers.map((x) => x.min), lc.min])].filter((m) => m >= 20 && m <= max).sort((a, b) => a - b);
      const ticks = marks.map((m) => { const s = el('span', 's26g__tick', usd(m)); s.style.left = (m / max * 100) + '%'; tickBox.appendChild(s); return { m, s }; });
      /* the filled part of the track: a stylesheet rule, so dragging writes no inline styles */
      const st = document.createElement('style'); document.head.appendChild(st);
      const rule = st.sheet.cssRules[st.sheet.insertRule('#' + CSS.escape(range.id) + '{--s26g-p:0%}', 0)].style;
      let A = -1;
      function set(v) {
        v = Math.max(0, Math.min(max, Math.round(v / 5) * 5));
        if (v === A) return; A = v;
        if (+range.value !== v) range.value = v;
        rule.setProperty('--s26g-p', (v / max * 100) + '%');
        setText(out, usd(v));
        ticks.forEach((x) => { const on = v >= x.m; if (x.on !== on) { x.on = on; x.s.classList.toggle('is-on', on); } });
        ROWS.forEach((r) => { if (r.li) setRow(r.li, v >= r.need ? 'on' : 'off', v >= r.need || r.k === 'spend' ? r.v(v) : esc(fill(t.locked, { amount: usd(r.need) }))); });
      }
      let sweep = null;
      range.addEventListener('input', () => { if (sweep) { sweep.kill(); sweep = null; } set(+range.value); });
      set(0);
      let swept = false;
      return {
        enter(delay) {
          if (swept) return; swept = true;
          const to = Math.min(max, num(data.start, 160));
          if (!G) { set(to); return; }
          const o = { v: 0 };
          sweep = G.to(o, { v: to, duration: 1.6, delay, ease: 'power3.inOut', onUpdate: () => set(o.v), onComplete: () => { sweep = null; } });
        }
      };
    })();

    /* ---- tool 2: a specific product — predictive search, then its offers ---- */
    const find = (() => {
      const p = panels.find; if (!p) return null;
      const form = p.querySelector('[data-g-find]'), q = p.querySelector('[data-g-q]');
      const status = p.querySelector('[data-g-status]'), res = p.querySelector('[data-g-results]'), picked = p.querySelector('[data-g-picked]');
      const words = String(data.newWords || '').split(',').map((w) => w.trim().toLowerCase()).filter(Boolean);
      const cur = (window.Shopify && Shopify.currency) || {};
      const rate = num(cur.rate, 1) || 1;
      let fmt = null;
      try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active || 'USD' }); } catch (e) {}
      const money = (v) => { const n = num(v, NaN); return isNaN(n) ? '' : fmt ? fmt.format(n) : '$' + n.toFixed(2); };
      let ctl = null, timer = 0, lastQ = '', found = [];
      const base = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
      function search(v, now) {
        clearTimeout(timer);
        const go = () => {
          v = v.trim(); if (v === lastQ) return; lastQ = v;
          if (ctl) ctl.abort();
          if (v.length < 2) { res.textContent = ''; setText(status, ''); return; }
          setText(status, t.searching || '');
          ctl = 'AbortController' in window ? new AbortController() : null;
          fetch(base + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctl ? { signal: ctl.signal } : {})
            .then((r) => (r.ok ? r.json() : Promise.reject(new Error('http'))))
            .then((j) => show(((j.resources || {}).results || {}).products || [], v))
            .catch((e) => { if (e && e.name === 'AbortError') return; setText(status, t.error || ''); res.textContent = ''; });
        };
        if (now) go(); else timer = setTimeout(go, 180);
      }
      function priceHTML(pr) {
        const a = money(pr.price), c = num(pr.compare_at_price_max, 0) > num(pr.price, 0) ? money(pr.compare_at_price_max) : '';
        return esc(a) + (c ? '<s>' + esc(c) + '</s>' : '');
      }
      const img = (pr) => { const u = (pr.featured_image && pr.featured_image.url) || pr.image || ''; return u ? u + (u.includes('?') ? '&' : '?') + 'width=160' : ''; };
      function show(list, v) {
        found = list; res.textContent = '';
        setText(status, list.length ? '' : fill(t.none, { q: v }));
        list.forEach((pr, i) => {
          const li = el('li'), b = el('button', 's26g__res'); b.type = 'button'; b.dataset.i = i;
          const u = img(pr);
          b.innerHTML = (u ? '<img alt="" loading="lazy" decoding="async" src="' + esc(u) + '">' : '<span></span>')
            + '<span><b>' + esc(pr.title) + '</b><small>' + esc(pr.vendor || '') + '</small></span>'
            + '<span class="s26g__price">' + priceHTML(pr) + '</span>';
          li.appendChild(b); res.appendChild(li);
        });
        if (G && list.length) G.fromTo(res.children, { y: 12, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .4, stagger: .05, ease: 'power3.out', overwrite: true });
      }
      function pick(pr) {
        res.textContent = ''; setText(status, '');
        picked.innerHTML = '';
        const head = el('div', 's26g__pk'), u = img(pr);
        head.innerHTML = (u ? '<img alt="" decoding="async" src="' + esc(u) + '">' : '<span></span>')
          + '<div><p class="s26g__pk-k">' + esc(t.pickTitle) + '</p><p class="s26g__pk-t"></p>'
          + '<p class="s26g__price">' + fill(esc(t.today), { price: priceHTML(pr) }) + '</p></div>'
          + '<div class="s26g__pk-a"><a class="s26g__row-go"></a><button type="button" class="s26g__pk-x"></button></div>';
        head.querySelector('.s26g__pk-t').textContent = pr.title;
        const a = head.querySelector('a'); a.href = pr.url; a.textContent = t.view || '';
        const x = head.querySelector('button'); x.textContent = t.clear || '';
        x.addEventListener('click', () => { picked.hidden = true; picked.innerHTML = ''; lastQ = ''; q.value = ''; q.focus(); });
        picked.appendChild(head);
        const ul = el('ul', 's26g__rows'); ul.setAttribute('role', 'list'); picked.appendChild(ul);
        const P = num(pr.price, 0) / rate;
        const isNew = words.some((w) => String(pr.title || '').toLowerCase().includes(w));
        const rows = [];
        if (isNew) {
          let r = rowFor('reservation', ul); if (r) rows.push([r, 'on', rich(t.fNew)]);
          r = rowFor('launch', ul); if (r) rows.push([r, 'on', esc(note(items.launch.why))]);
        }
        const boostRow = () => { const b = rowFor('boost', ul); if (b) rows.push([b, 'on', rich(t.fBoost)]); };
        if (isFeat('boost')) boostRow();
        let r = rowFor('deals', ul); if (r) rows.push([r, 'on', rich(t.fDeals)]);
        r = rowFor('spend', ul); if (r) rows.push([r, tiers.length && P >= tiers[0].min ? 'on' : 'off', spendText(P)]);
        r = rowFor('lastcall', ul);
        if (r) rows.push(P >= lc.min ? [r, 'on', rich(fill(t.lastcall, { back: usd(Math.min(P * lc.pct / 100, lc.cap)) }))] : [r, 'off', esc(fill(t.locked, { amount: usd(lc.min) }))]);
        if (!isFeat('boost')) boostRow();
        rows.forEach(([li, s, h]) => setRow(li, s, h));
        picked.hidden = false;
        if (G) G.fromTo([head, ...ul.children], { y: 14, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .45, stagger: .06, ease: 'power3.out' });
      }
      q.addEventListener('input', () => search(q.value));
      form.addEventListener('submit', (e) => { e.preventDefault(); if (found.length && res.children.length) pick(found[0]); else search(q.value, true); });
      res.addEventListener('click', (e) => { const b = e.target.closest('.s26g__res'); if (b && found[+b.dataset.i]) pick(found[+b.dataset.i]); });
      p.addEventListener('click', (e) => {
        const b = e.target.closest('[data-g-try]'); if (!b) return;
        q.value = b.dataset.gTry; picked.hidden = true; search(q.value, true); q.focus({ preventScroll: true });
      });
      return {
        enter(delay) {
          if (G) G.fromTo(p.querySelectorAll('.s26g__ex > *'), { y: 10, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .4, delay: delay + .1, stagger: .05, ease: 'power3.out' });
          setTimeout(() => q.focus({ preventScroll: true }), G ? delay * 1000 + 250 : 0);
        }
      };
    })();

    /* ---- tool 3: a special date — the key days, what opens, add to calendar ---- */
    const date = (() => {
      const p = panels.date; if (!p) return null;
      const box = p.querySelector('[data-g-days]'), ind = p.querySelector('[data-g-ind]'), out = p.querySelector('[data-g-day]');
      const days = new Map();
      const add = (d, k, kind) => { if (d == null) return; if (!days.has(d)) days.set(d, { d, opens: [], ends: [] }); days.get(d)[kind].push(k); };
      Object.keys(items).forEach((k) => add(dUTC(items[k].from), k, 'opens'));
      const fin = dUTC(data.final);
      if (fin != null) Object.keys(items).forEach((k) => { if (dUTC(items[k].to) === fin) add(fin, k, 'ends'); });
      const list = [...days.values()].sort((a, b) => a.d - b.d);
      if (!list.length) return null;
      const f = (d, o) => new Intl.DateTimeFormat(document.documentElement.lang || 'en', Object.assign({ timeZone: 'UTC' }, o)).format(d);
      list.forEach((x) => {
        const b = el('button', 's26g__dt'); b.type = 'button'; b.setAttribute('aria-pressed', 'false');
        const n = x.opens.length;
        const cap = x.d === fin && !n ? t.dayFinal : n === 1 ? t.dayOne : fill(t.dayCount, { count: n });
        b.innerHTML = '<span class="s26g__dt-w"></span><span class="s26g__dt-d"></span><span class="s26g__dt-c"></span>';
        b.children[0].textContent = f(x.d, { weekday: 'short' });
        b.children[1].textContent = f(x.d, { day: 'numeric' });
        b.children[1].appendChild(el('small', '', f(x.d, { month: 'short' })));
        b.children[2].textContent = cap;
        if (x.d < today) b.classList.add('is-past');
        x.b = b; box.appendChild(b);
      });
      let sel = null;
      function place(animate) {
        if (!sel) return;
        const b = sel.b, g = { x: b.offsetLeft, y: b.offsetTop, width: b.offsetWidth, height: b.offsetHeight, opacity: 1 };
        box.classList.add('has-ind');
        if (G && animate) G.to(ind, Object.assign({ duration: .5, ease: 'power3.out', overwrite: true }, g));
        else if (G) G.set(ind, g);
        else { ind.style.transform = 'translate(' + g.x + 'px,' + g.y + 'px)'; ind.style.width = g.width + 'px'; ind.style.height = g.height + 'px'; ind.style.opacity = 1; }
      }
      function status(d) {
        const n = Math.round((d - today) / DAY);
        return n === 0 ? t.isToday : n === 1 ? t.tomorrow : n > 1 ? fill(t.inDays, { n }) : t.past;
      }
      function choose(x, animate) {
        if (sel === x) return;
        if (sel) sel.b.setAttribute('aria-pressed', 'false');
        sel = x; x.b.setAttribute('aria-pressed', 'true');
        place(animate);
        if (box.scrollWidth > box.clientWidth) box.scrollTo({ left: x.b.offsetLeft - 4, behavior: reduced ? 'auto' : 'smooth' });
        out.innerHTML = '';
        const head = el('div', 's26g__day-head'), h = el('h3', 's26g__day-t');
        h.textContent = f(x.d, { weekday: 'long' }) + ', ';
        h.appendChild(el('em', '', f(x.d, { month: 'long', day: 'numeric' }) + '.'));
        head.append(h, el('span', 's26g__day-s', status(x.d)));
        out.appendChild(head);
        [['opens', t.opens], ['ends', t.ends]].forEach(([kind, label]) => {
          if (!x[kind].length) return;
          out.appendChild(el('p', 's26g__day-sub', label));
          const ul = el('ul', 's26g__rows'); ul.setAttribute('role', 'list'); out.appendChild(ul);
          x[kind].forEach((k) => { const li = rowFor(k, ul, true); if (li) setRow(li, 'on', esc(note(items[k].why))); });
        });
        if (x.d >= today) {
          const c = el('button', 's26g__ics'); c.type = 'button';
          c.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M3 10h18M8 3v4M16 3v4M12 13v5M9.5 15.5h5"/></svg>';
          c.appendChild(document.createTextNode(t.ics || ''));
          c.addEventListener('click', () => ics(x, c));
          out.appendChild(c);
        }
        if (G && animate) G.fromTo(out.children, { y: 12, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .4, stagger: .05, ease: 'power3.out' });
      }
      function ics(x, btn) {
        /* the reminder is for the day's first opening: an offer's "from" may carry a time
           (2026-10-26 10:00, GMT+8); without one the day starts at 00:00 */
        const at = (k) => { const m = /\s(\d{1,2}):(\d{2})/.exec(items[k].from || ''); return m ? +m[1] * 60 + +m[2] : 0; };
        const first = x.opens.length ? Math.min(...x.opens.map(at)) : 0;
        const start = x.d - 8 * 3600e3 + first * 60e3, name = f(x.d, { month: 'long', day: 'numeric' });
        const what = [...x.opens, ...x.ends].map((k) => '• ' + items[k].title + ' (' + items[k].dates + ')').join('\n');
        window.s26Cal.menu(btn, { title: fill(t.icsTitle, { day: name }), start, end: start + 3600e3, details: what,
          url: location.origin + location.pathname, alarm: 0, file: (t.icsFile || 'calendar') + '-' + new Date(x.d).toISOString().slice(0, 10) });
      }
      box.addEventListener('click', (e) => { const b = e.target.closest('.s26g__dt'); const x = b && list.find((y) => y.b === b); if (x) choose(x, true); });
      addEventListener('resize', () => place(false), { passive: true });
      return {
        enter(delay) {
          const next = list.find((x) => x.d >= today) || list[list.length - 1];
          if (!G) { choose(next, false); return; }
          G.fromTo(list.map((x) => x.b), { y: 16, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .45, delay, stagger: .05, ease: 'power3.out',
            onComplete: () => choose(next, true) });
        },
        relayout() { place(false); }
      };
    })();

    const tools = { save, find, date };
    let mode = null;
    function open(m, focusTab) {
      if (m === mode || !panels[m]) return;
      const first = !mode;
      const h0 = first ? 0 : stage.offsetHeight;
      mode = m;
      tabs.forEach((b) => { const on = b.dataset.gMode === m; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
      if (focusTab) tabs.find((b) => b.dataset.gMode === m).focus();
      Object.keys(panels).forEach((k) => setHidden(panels[k], k !== m));
      if (first) { app.classList.add('is-open'); setHidden(stage, false); }
      const tool = tools[m];
      if (!G) { if (tool) tool.enter(0); if (m === 'date' && tool) tool.relayout(); return; }
      if (first) {
        G.fromTo(tabs, { y: -10, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .45, stagger: .06, ease: 'power3.out' });
        G.fromTo(stage, { y: 28, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .6, delay: .1, ease: 'power3.out', clearProps: 'transform' });
      } else {
        const h1 = stage.offsetHeight;
        G.fromTo(stage, { height: h0, overflow: 'hidden' }, { height: h1, duration: .4, ease: 'power3.inOut', clearProps: 'height,overflow' });
        G.fromTo(panels[m], { y: 12, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: .35, delay: .05, ease: 'power3.out' });
      }
      if (tool) tool.enter(first ? .35 : .1);
    }
    /* the first answer: a short press on the cards, then the tool takes over */
    function pickFirst(m) {
      if (mode || !G) { open(m); return; }
      const chosen = tabs.find((b) => b.dataset.gMode === m);
      G.timeline()
        .to(tabs.filter((b) => b !== chosen), { autoAlpha: .35, scale: .97, duration: .18, ease: 'power2.out' }, 0)
        .to(chosen, { scale: .97, duration: .12, ease: 'power2.out' }, 0)
        .set(tabs, { clearProps: 'transform,opacity,visibility' })
        .add(() => open(m));
    }
    tabs.forEach((b) => b.addEventListener('click', () => pickFirst(b.dataset.gMode)));
    app.querySelector('[data-g-choices]').addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement); if (i < 0) return;
      const n = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      let j = n ? (i + n + tabs.length) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
      if (j < 0) return;
      e.preventDefault();
      if (mode) open(tabs[j].dataset.gMode, true); else tabs[j].focus();
    });

    /* ---- popup mode: a button at the bottom of the screen opens the guide in a dialog ---- */
    const dlg = root.querySelector('[data-g-dlg]'), launch = root.querySelector('[data-g-launch]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    let place = () => {};
    const show = () => { if (dlg.open) return; dlg.showModal(); dlg.focus(); warm(); place(); };
    dlg.addEventListener('close', () => place());
    dlg.addEventListener('click', (e) => {
      /* the backdrop, the close button, or a link to an offer further down the page */
      if (e.target === dlg || e.target.closest('[data-g-close]') || e.target.closest('a[href^="#"]')) dlg.close();
    });
    const anchor = root.querySelector('.bts-anchor');
    if (anchor && anchor.id) {
      document.addEventListener('click', (e) => {
        const a = e.target instanceof Element && e.target.closest('a[href="#' + anchor.id + '"]');
        if (a && !dlg.contains(a)) { e.preventDefault(); show(); }
      });
    }
    if (!launch) return;
    /* moved to <body>: a section wrapper with a transform or isolation would trap position: fixed.
       A re-render in the theme editor leaves the old one behind, so clear it first. */
    document.querySelectorAll('body > .s26g__launch[aria-controls="' + launch.getAttribute('aria-controls') + '"]').forEach((b) => b.remove());
    document.body.appendChild(launch);
    launch.addEventListener('click', show);
    /* shown once the visitor is past the first screen (the homepage copy says how far: data-g-show, % of a
       screen); reads scrollY only, writes only on change */
    const showAt = root.dataset.gShow != null ? Number(root.dataset.gShow) / 100 : .6;
    let ticking = false;
    place = () => { ticking = false; setHidden(launch, dlg.open || scrollY < innerHeight * showAt); };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(place); } }, { passive: true });
    place();
  }

  /* ---------- product peek: one shared preview card for every [data-s26-peek] chip ----------
     Mouse hover or keyboard focus shows it; touch just follows the link. Built once, moved
     through a stylesheet rule, and its text is rewritten only when it points at a new chip,
     so hovering along a row of chips is cheap for the translation app's observer. */
  let peekBound = false, pk = null, pkRule = null, pkFor = null, pkShow = 0, pkHide = 0;
  function buildPeek() {
    pk = el('div', 's26-peek');
    pk.setAttribute('aria-hidden', 'true');
    pk.innerHTML = '<div class="s26-peek__img"><img alt="" decoding="async"></div>'
      + '<div class="s26-peek__tx"><p class="s26-peek__type"></p><p class="s26-peek__t"></p>'
      + '<p class="s26-peek__price"><span></span><b></b><span></span></p>'
      + '<p class="s26-peek__rate"><i aria-hidden="true">★</i><b></b><span></span></p>'
      + '<p class="s26-peek__go"></p></div>';
    document.body.appendChild(pk);
    const st = document.createElement('style');
    document.head.appendChild(st);
    pkRule = st.sheet.cssRules[st.sheet.insertRule('html .s26-peek.s26-peek{}', 0)].style;
    const img = pk.querySelector('img');
    img.addEventListener('load', () => img.parentNode.classList.remove('is-loading'));
  }
  function fillPeek(a) {
    const d = a.dataset, host = a.closest('[data-peek-view]'), lab = host ? host.dataset : {};
    const q = (s) => pk.querySelector(s);
    const img = q('img'), well = q('.s26-peek__img');
    setHidden(well, !d.pImg);
    if (d.pImg && img.getAttribute('src') !== d.pImg) { well.classList.add('is-loading'); img.src = d.pImg; }
    setText(q('.s26-peek__type'), d.pType || ''); setHidden(q('.s26-peek__type'), !d.pType);
    setText(q('.s26-peek__t'), d.pTitle || '');
    const pr = q('.s26-peek__price').children;
    if (d.pSoldout !== undefined) { setText(pr[0], lab.peekSoldout || ''); setText(pr[1], ''); setText(pr[2], ''); }
    else {
      const parts = (lab.peekWorth || '[price]').split('[price]');
      setText(pr[0], parts[0] || ''); setText(pr[1], d.pWorth || ''); setText(pr[2], parts.slice(1).join('') || '');
    }
    const rate = q('.s26-peek__rate');
    setHidden(rate, !d.pRating);
    if (d.pRating) { setText(rate.children[1], d.pRating); setText(rate.children[2], (lab.peekReviews || '[count]').replace('[count]', d.pCount || '')); }
    setText(q('.s26-peek__go'), lab.peekView || ''); setHidden(q('.s26-peek__go'), !lab.peekView);
  }
  function showPeek(a) {
    clearTimeout(pkHide);
    if (!pk) buildPeek();
    if (pkFor !== a) {
      if (pkFor) pkFor.classList.remove('is-peek');
      pkFor = a; a.classList.add('is-peek');
      fillPeek(a);
    }
    const r = a.getBoundingClientRect(), w = pk.offsetWidth, h = pk.offsetHeight, m = 12;
    const x = Math.max(m, Math.min(innerWidth - w - m, r.left + r.width / 2 - w / 2));
    let y = r.top - h - 10;
    let top = headerOffset();
    const bar = document.querySelector('[data-s26-nav]');
    if (bar) { const b = bar.getBoundingClientRect(); if (b.top <= top + 2 && b.bottom > top) top = b.bottom; }
    const below = y < top + m;
    if (below) y = r.bottom + 10;
    pkRule.setProperty('left', Math.round(x) + 'px');
    pkRule.setProperty('top', Math.round(y) + 'px');
    if (below !== pk.hasAttribute('data-below')) pk.toggleAttribute('data-below', below);
    if (!pk.classList.contains('is-on')) requestAnimationFrame(() => pk.classList.add('is-on'));
  }
  function hidePeek() {
    clearTimeout(pkShow);
    if (!pk || !pkFor) return;
    pk.classList.remove('is-on');
    pkFor.classList.remove('is-peek');
    pkFor = null;
  }
  function bindPeek() {
    if (peekBound) return;
    peekBound = true;
    const chip = (t) => (t instanceof Element ? t.closest('[data-s26-peek]') : null);
    document.addEventListener('pointerover', (e) => {
      if (e.pointerType !== 'mouse' || !fine.matches) return;
      const a = chip(e.target); if (!a) return;
      clearTimeout(pkHide); clearTimeout(pkShow);
      pkShow = setTimeout(() => showPeek(a), pk && pk.classList.contains('is-on') ? 0 : 90);
    });
    document.addEventListener('pointerout', (e) => {
      const a = chip(e.target); if (!a || a.contains(e.relatedTarget)) return;
      clearTimeout(pkShow); pkHide = setTimeout(hidePeek, 110);
    });
    document.addEventListener('focusin', (e) => { const a = chip(e.target); if (a && a.matches(':focus-visible')) showPeek(a); });
    document.addEventListener('focusout', (e) => { if (chip(e.target)) pkHide = setTimeout(hidePeek, 80); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hidePeek(); });
    addEventListener('scroll', () => { if (pkFor) hidePeek(); }, { passive: true });
    addEventListener('resize', () => { if (pkFor) hidePeek(); }, { passive: true });
  }

  /* ---------- select menus, after Linsoul's ls-select.js ----------
     On mouse screens a <select> gets a button + listbox drawn like the rest of the page; the
     select stays (hidden) as the value, and picking sets it and fires `change`, so the filter
     code is unchanged. Touch screens keep the browser's own picker. Counts written as
     "Label (12)" are shown apart, in grey. */
  const SEL_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  let selUid = 0, selOpen = null, selBound = false;
  const selSplit = (t) => { const m = /^(.*?)\s*\((\d[\d,]*)\)\s*$/.exec(t); return m ? [m[1], m[2]] : [t, '']; };
  function syncSelect(sel) {
    const st = sel && sel._s26sel; if (!st) return;
    const i = sel.selectedIndex, o = sel.options[i];
    setText(st.btn.firstChild, o ? selSplit(o.textContent.trim())[0] : '');
    st.list.querySelectorAll('[role=option]').forEach((li) => { const on = String(+li.dataset.i === i); if (li.getAttribute('aria-selected') !== on) li.setAttribute('aria-selected', on); });
  }
  function enhanceSelect(sel) {
    if (!sel || sel._s26sel || !fine.matches) return;
    const field = sel.closest('.s26dl__sel'); if (!field) return;
    const id = 's26-sel-' + (++selUid);
    const lab = field.querySelector('.s26dl__sel-l'); if (lab && !lab.id) lab.id = id + '-l';
    const btn = el('button', 's26-sel'); btn.type = 'button';
    btn.setAttribute('role', 'combobox'); btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', id);
    const val = el('span', 's26-sel__value'); val.id = id + '-v'; btn.appendChild(val);
    if (lab) btn.setAttribute('aria-labelledby', lab.id + ' ' + val.id);
    const list = el('ul', 's26-sel__list'); list.id = id; list.setAttribute('role', 'listbox'); list.hidden = true;
    if (lab) list.setAttribute('aria-labelledby', lab.id);
    [...sel.options].forEach((o, i) => {
      const [t, n] = selSplit(o.textContent.trim());
      const li = el('li', 's26-sel__opt'); li.setAttribute('role', 'option'); li.id = id + '-' + i; li.dataset.i = i; li.setAttribute('aria-selected', 'false');
      li.appendChild(el('span', 's26-sel__label', t));
      if (n) li.appendChild(el('span', 's26-sel__count', n));
      const ck = el('span', 's26-sel__check'); ck.innerHTML = SEL_CHECK; li.appendChild(ck);
      list.appendChild(li);
    });
    sel.classList.add('s26-sel-native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    sel.before(btn); btn.after(list);
    const st = sel._s26sel = { sel, btn, list, field, active: -1, typed: '', at: 0 };
    syncSelect(sel);
    const opts = () => [...list.children];
    const setActive = (i, scroll) => {
      st.active = i;
      opts().forEach((li) => li.classList.toggle('is-active', +li.dataset.i === i));
      const li = list.children[i];
      if (li) { btn.setAttribute('aria-activedescendant', li.id); if (scroll) li.scrollIntoView({ block: 'nearest' }); }
    };
    const close = () => { list.hidden = true; list.classList.remove('is-in'); btn.setAttribute('aria-expanded', 'false'); btn.removeAttribute('aria-activedescendant'); field.classList.remove('is-open'); if (selOpen === st) selOpen = null; };
    const show = () => {
      if (selOpen && selOpen !== st) selOpen.close();
      syncSelect(sel); selOpen = st; st.close = close;
      list.hidden = false; btn.setAttribute('aria-expanded', 'true'); field.classList.add('is-open');
      list.removeAttribute('data-up'); list.removeAttribute('data-align');
      const r = field.getBoundingClientRect(), h = Math.min(list.scrollHeight, 340), below = innerHeight - r.bottom;
      if (below < h + 16 && r.top > below) list.setAttribute('data-up', '');
      if (r.left + list.getBoundingClientRect().width > document.documentElement.clientWidth - 12) list.setAttribute('data-align', 'end');
      setActive(sel.selectedIndex, true);
      if (!reduced) { list.classList.remove('is-in'); void list.offsetWidth; list.classList.add('is-in'); }
    };
    st.close = close;
    const pick = (i) => { if (sel.selectedIndex !== i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); } syncSelect(sel); };
    btn.addEventListener('click', (e) => { e.preventDefault(); selOpen === st ? close() : show(); });
    list.addEventListener('mousedown', (e) => { if (e.target.closest('[role=option]')) e.preventDefault(); });
    list.addEventListener('click', (e) => { e.preventDefault(); const li = e.target.closest('[role=option]'); if (!li) return; pick(+li.dataset.i); close(); btn.focus({ preventScroll: true }); });
    list.addEventListener('mousemove', (e) => { const li = e.target.closest('[role=option]'); if (li && +li.dataset.i !== st.active) setActive(+li.dataset.i, false); });
    btn.addEventListener('keydown', (e) => {
      const open = selOpen === st, n = list.children.length;
      const move = (to) => { e.preventDefault(); if (!open) show(); setActive(Math.max(0, Math.min(n - 1, to)), true); };
      if (e.key === 'ArrowDown') return open ? move(st.active + 1) : (e.preventDefault(), show());
      if (e.key === 'ArrowUp') return open ? move(st.active - 1) : (e.preventDefault(), show());
      if (e.key === 'Home' && open) return move(0);
      if (e.key === 'End' && open) return move(n - 1);
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (!open) return show(); if (st.active > -1) pick(st.active); return close(); }
      if (e.key === 'Escape' && open) { e.preventDefault(); e.stopPropagation(); return close(); }
      if (e.key === 'Tab' && open) return close();
      if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const now = Date.now(); st.typed = (now - st.at > 700 ? '' : st.typed) + e.key.toLowerCase(); st.at = now;
        const hit = [...sel.options].findIndex((o) => o.textContent.trim().toLowerCase().startsWith(st.typed));
        if (hit < 0) return; e.preventDefault(); if (open) setActive(hit, true); else pick(hit);
      }
    });
    if (!selBound) {
      selBound = true;
      document.addEventListener('pointerdown', (e) => { if (selOpen && !selOpen.field.contains(e.target)) selOpen.close(); }, true);
      addEventListener('resize', () => { if (selOpen) selOpen.close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && selOpen) { const st = selOpen; st.close(); st.btn.focus({ preventScroll: true }); } });
    }
  }

  /* ---------- when a part runs + countdown (snippets/sale26-time.liquid) ----------
     Before it opens: "Starts <from>" counting down to it; while open: "Ends <to>" counting down;
     after: "Ended" without a countdown. Blue in the last 24 hours. Ticks once a second, only
     while on screen, and writes only what changed. */
  const T_MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const tFmt = (ms) => { const d = new Date(ms + 8 * 3600e3); return T_MON[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + String(d.getUTCHours()).padStart(2, '0') + ':' + String(d.getUTCMinutes()).padStart(2, '0') + ' GMT+8'; };
  const tTimers = new Set();
  let tLoop = 0;
  const tIO = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { e.target._tVis = e.isIntersecting; if (e.isIntersecting) tickTime(e.target); })) : null;
  function tickTime(el) {
    const f = el._tFrom, t = el._tTo, now = nowMs();
    const phase = f != null && now < f ? 'upcoming' : t != null && now >= t ? 'ended' : 'live';
    if (el._tPhase !== phase) {
      el._tPhase = phase;
      el.dataset.phase = phase;
      setText(el.querySelector('[data-t-label]'), phase === 'upcoming' ? el.dataset.lu : phase === 'live' ? el.dataset.ll : el.dataset.le);
      /* an end at midnight reads as the minute before: "Nov 15, 23:59", the last day it runs */
      const at = phase === 'upcoming' ? f : t != null ? t - (new Date(t + 8 * 3600e3).getUTCHours() === 0 && new Date(t).getUTCMinutes() === 0 ? 60e3 : 0) : f;
      if (at != null) setText(el.querySelector('[data-t-date]'), tFmt(at));
      /* open-ended (no end date): once live there is no "Ends …" to state, rather than the start date under that label */
      setHidden(el.querySelector('.s26-time__line'), phase === 'live' && t == null);
      setHidden(el.querySelector('[data-t-cd]'), phase === 'ended' || (phase === 'live' && t == null));
    }
    const target = phase === 'upcoming' ? f : phase === 'live' ? t : null;
    if (target == null) return;
    const s = Math.max(0, Math.floor((target - now) / 1000));
    const soon = phase === 'live' && s < 86400;
    if (el.classList.contains('is-soon') !== soon) el.classList.toggle('is-soon', soon);
    const u = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
    Object.keys(u).forEach((k) => setText(el.querySelector('[data-u="' + k + '"]'), String(u[k]).padStart(2, '0')));
  }
  function initTime(el) {
    if (el._tReady) return; el._tReady = true;
    el._tFrom = el.dataset.from ? ts(el.dataset.from) : null;
    el._tTo = el.dataset.to ? ts(el.dataset.to) : null;
    if (el._tFrom != null && isNaN(el._tFrom)) el._tFrom = null;
    if (el._tTo != null && isNaN(el._tTo)) el._tTo = null;
    tTimers.add(el); el._tVis = !tIO;
    if (tIO) tIO.observe(el);
    tickTime(el);
    if (!tLoop) tLoop = setInterval(() => { if (document.hidden) return; tTimers.forEach((x) => { if (!x.isConnected) tTimers.delete(x); else if (x._tVis) tickTime(x); }); }, 1000);
  }

  /* ---------- sitewide deals: category pills, brand / price / sort menus, "View more" ----------
     Cards are drawn once by Liquid; this only hides, shows and re-orders them (CSS order), so
     the store's translation app, which re-scans on every added node, has nothing to re-scan. */
  function initDeals(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    const grid = root.querySelector('[data-d-grid]'); if (!grid) return;
    const items = [...grid.querySelectorAll('[data-d-item]')].map((li) => {
      const title = li.dataset.title || '';
      const words = title.split(/[\s\/,()+×]+/).filter(Boolean);
      /* the model number in the name: RT75 -> 75, TH108 -> 108, "Split 65" -> 65 */
      const nums = words.map((w) => { const m = w.match(/^[a-z]*(\d{2,3})[a-z]*$/); return m ? +m[1] : null; }).filter((n) => n != null);
      return { li, i: +li.dataset.i, cats: li.dataset.cats || '|', price: +li.dataset.price || 0, off: +li.dataset.off || 0,
        vendor: li.dataset.vendor || '', title: ' ' + title + ' ', name: title, date: +li.dataset.date || 0, words, nums, tags: li.dataset.tags || '||', fac: [] };
    });
    const pills = [...root.querySelectorAll('[data-d-cat]')];
    const sels = {}; root.querySelectorAll('[data-d-sel]').forEach((x) => { sels[x.dataset.dSel] = x; });
    const more = root.querySelector('[data-d-more]'), empty = root.querySelector('[data-d-empty]'), count = root.querySelector('[data-d-count]');
    const box = root.querySelector('[data-d-facets-box]');
    const size = Math.max(1, +root.dataset.page || 8);
    const st = { cat: '', vendor: '', price: '', sort: '', f: {} };
    let pages = 1;

    /* ---- filter menus: "Option = rule, rule" lines, matched once per product ---- */
    let facets = [];
    try { facets = JSON.parse(root.querySelector('[data-d-facets]').textContent) || []; } catch (e) {}
    facets = facets.map((f) => ({
      cat: f.cat || '', label: f.label || '', all: f.all || f.label || '',
      opts: String(f.options || '').split('\n').map((ln) => {
        const k = ln.indexOf('='); if (k < 1) return null;
        const rules = ln.slice(k + 1).split(',').map((r) => r.trim().toLowerCase()).filter(Boolean).map((r) => {
          if (r === '*') return { t: 'rest' };
          if (r.startsWith('tag:')) return { t: 'tag', v: '|' + r.slice(4).trim() + '|' };
          if (r.startsWith('num:')) { const [a, b] = r.slice(4).split('-').map(Number); return { t: 'num', lo: a, hi: isNaN(b) ? a : b }; }
          return r.includes(' ') ? { t: 'phrase', v: ' ' + r + ' ' } : { t: 'word', v: r };
        });
        return { label: ln.slice(0, k).trim(), rules };
      }).filter((o) => o && o.label && o.rules.length)
    })).filter((f) => f.opts.length);
    const hit = (x, r) => r.t === 'tag' ? x.tags.includes(r.v)
      : r.t === 'phrase' ? x.title.includes(r.v)
      : r.t === 'word' ? x.words.some((w) => w.startsWith(r.v))
      : r.t === 'num' ? x.nums.some((n) => n >= r.lo && n <= r.hi) : false;
    items.forEach((x) => {
      x.fac = facets.map((f) => {
        const pick = (types) => f.opts.reduce((a, o, k) => (o.rules.some((r) => types.includes(r.t) && hit(x, r)) ? a.concat(k) : a), []);
        let on = pick(['tag', 'phrase', 'word']);
        if (!on.length) on = pick(['num']);
        if (!on.length) on = f.opts.reduce((a, o, k) => (o.rules.some((r) => r.t === 'rest') ? a.concat(k) : a), []);
        return new Set(on);
      });
    });
    const catLabel = (c) => { const b = pills.find((p) => p.dataset.dCat === c); const t = b && (b.querySelector('span') || b); return t ? t.textContent.trim().toLowerCase() : ''; };
    const inCat = (x) => !st.cat || x.cats.includes('|' + st.cat + '|');
    /* the menus for the chosen category, with how many products each option holds */
    function buildFacets() {
      if (!box) return;
      box.textContent = ''; st.f = {};
      const lab = catLabel(st.cat), pool = items.filter(inCat);
      facets.forEach((f, fi) => {
        if (f.cat && f.cat !== lab) return;
        const n = f.opts.map((o, k) => pool.filter((x) => x.fac[fi].has(k)).length);
        if (n.filter((c) => c > 0).length < 2) return;
        const wrap = el('label', 's26dl__sel'); wrap.appendChild(el('span', 's26dl__sel-l', f.label));
        const sel = el('select'); sel.appendChild(new Option(f.all, ''));
        f.opts.forEach((o, k) => { if (n[k]) sel.appendChild(new Option(o.label + ' (' + n[k] + ')', String(k))); });
        sel.addEventListener('change', () => { if (sel.value === '') delete st.f[fi]; else st.f[fi] = +sel.value; pages = 1; apply(); });
        wrap.appendChild(sel); box.appendChild(wrap); enhanceSelect(sel);
      });
    }
    /* cards past the first page come as placeholders (snippets/sale26-deal-card): fetch the real card
       for those about to be seen, through sections/sale26-card-render on the product's own URL */
    function fill(xs) {
      xs.forEach((x) => {
        const ph = x.li.querySelector('[data-d-lazy]');
        if (!ph || x.loading) return;
        x.loading = true;
        const u = new URL(ph.getAttribute('href'), location.origin);
        u.searchParams.set('section_id', 'sale26-card-render');
        fetch(u, { credentials: 'same-origin' }).then((r) => (r.ok ? r.text() : Promise.reject()))
          .then((html) => {
            const d = new DOMParser().parseFromString(html, 'text/html');
            const wrap = d.body.firstElementChild;
            if (!wrap || !wrap.firstElementChild) return Promise.reject();
            x.li.replaceChildren(...wrap.childNodes);
          })
          .catch(() => { x.loading = false; });
      });
    }
    function apply() {
      let lo = 0, hi = Infinity;
      if (st.price) { const [a, b] = st.price.split('-'); lo = +a || 0; hi = b === '' ? Infinity : +b; }
      const fk = Object.keys(st.f);
      const list = items.filter((x) => inCat(x) && (!st.vendor || x.vendor === st.vendor) && x.price >= lo && x.price < hi
        && fk.every((fi) => x.fac[fi].has(st.f[fi])));
      const by = {
        low: (a, b) => a.price - b.price || a.i - b.i, high: (a, b) => b.price - a.price || a.i - b.i, off: (a, b) => b.off - a.off || a.i - b.i,
        az: (a, b) => a.name.localeCompare(b.name) || a.i - b.i, za: (a, b) => b.name.localeCompare(a.name) || a.i - b.i,
        new: (a, b) => b.date - a.date || a.i - b.i, old: (a, b) => a.date - b.date || a.i - b.i
      }[st.sort] || ((a, b) => a.i - b.i);
      list.sort(by);
      const on = new Set(list.slice(0, pages * size));
      list.forEach((x, k) => { const o = String(k); if (x.li.style.order !== o) x.li.style.order = o; });
      items.forEach((x) => setHidden(x.li, !on.has(x)));
      setHidden(more, list.length <= pages * size);
      setHidden(empty, list.length > 0);
      fill(list.slice(0, pages * size));
      /* the next page too, once the browser is idle, so "View more" opens on finished cards */
      const next = list.slice(pages * size, (pages + 1) * size);
      if (next.length) (window.requestIdleCallback || ((f) => setTimeout(f, 600)))(() => fill(next));
      if (count) setText(count, (list.length === 1 ? root.dataset.one : (root.dataset.many || '')).replace('[count]', list.length));
      root.querySelectorAll('.s26dl__sel select').forEach((x) => { const set = x.value !== ''; const f = x.closest('.s26dl__sel'); if (f && f.classList.contains('is-set') !== set) f.classList.toggle('is-set', set); syncSelect(x); });
    }
    pills.forEach((b) => b.addEventListener('click', () => {
      if (st.cat === b.dataset.dCat) return;
      st.cat = b.dataset.dCat; pages = 1;
      pills.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      buildFacets(); apply();
    }));
    Object.keys(sels).forEach((k) => sels[k].addEventListener('change', () => { st[k] = sels[k].value; pages = 1; apply(); }));
    if (more) more.addEventListener('click', () => { pages++; apply(); });
    const reset = root.querySelector('[data-d-reset]');
    if (reset) reset.addEventListener('click', () => {
      st.cat = st.vendor = st.price = st.sort = ''; pages = 1;
      Object.values(sels).forEach((x) => { x.value = ''; });
      pills.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.dCat === '')));
      buildFacets(); apply();
    });
    Object.values(sels).forEach(enhanceSelect);
    /* how many products each category holds */
    pills.forEach((b) => { const n = b.querySelector('[data-d-catn]'); if (n) setText(n, String(items.filter((x) => !b.dataset.dCat || x.cats.includes('|' + b.dataset.dCat + '|')).length)); });
    buildFacets(); apply();
  }

  /* ---------- flash deals: per-card window, countdown pill, draining time bar ---------- */
  function initFlash(root) {
    if (root.dataset.s26Ready) return; root.dataset.s26Ready = '1';
    const d = root.dataset, U = (d.units || 'd,h,m,s').split(',');
    const left = (ms) => {
      const x = Math.max(0, Math.floor(ms / 1000)), dd = Math.floor(x / 86400), h = Math.floor(x / 3600) % 24, m = Math.floor(x / 60) % 60, s = x % 60;
      if (dd) return dd + (U[0] || 'd') + ' ' + pad(h) + (U[1] || 'h');
      if (h) return pad(h) + (U[1] || 'h') + ' ' + pad(m) + (U[2] || 'm');
      return pad(m) + (U[2] || 'm') + ' ' + pad(s) + (U[3] || 's');
    };
    const cards = [...root.querySelectorAll('.s26f__card')].map((c) => ({
      c, a: ts(c.dataset.from), b: ts(c.dataset.to), k: null,
      pill: c.querySelector('[data-f-status]'), live: c.querySelector('[data-f-live]'), soon: c.querySelector('[data-f-soon]'),
      done: c.querySelector('[data-f-done]'), bar: c.querySelector('.s26f__time'),
    }));
    const paint = () => {
      const now = nowMs();
      cards.forEach((o) => {
        let k = 'live', label = '';
        if (o.a && now < o.a) { k = 'soon'; label = (d.lSoon || '').replace('[time]', left(o.a - now)).replace('[date]', fmtDay(o.a + 8 * 3600e3)); }
        else if (o.b && now >= o.b) { k = 'done'; label = d.lDone || ''; }
        else if (o.b) label = (d.lLive || '').replace('[time]', left(o.b - now));
        if (o.k !== k) {
          if (o.k) o.c.classList.remove('is-' + o.k);
          o.c.classList.add('is-' + k); o.k = k;
          setHidden(o.live, k !== 'live'); setHidden(o.soon, k !== 'soon'); setHidden(o.done, k !== 'done');
        }
        if (o.pill) { setText(o.pill, label); setHidden(o.pill, !label); }
        if (k === 'live' && o.a && o.b && o.bar) {
          const v = Math.max(0, Math.min(1, (o.b - now) / (o.b - o.a))).toFixed(3);
          if (o.bar._v !== v) { o.bar._v = v; o.bar.style.setProperty('--left', v); }
        }
      });
    };
    paint();
    let on = false;
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => { on = es[0].isIntersecting; if (on) paint(); }, { rootMargin: '100px 0px' }).observe(root);
    else on = true;
    let beat = 0;
    setInterval(() => { beat++; if ((on && !document.hidden) || beat % 30 === 0) paint(); }, 1000);
  }

  /* ---------- section menu: sticks under the site header, lights the section in view ---------- */
  /* bh-header publishes how much of the window it covers as --bh-header-offset (the compact
     bar's height, 0 while no header is on screen) and fires bh:header-offset when it changes;
     the menu's CSS sticks at that value, and the JS reads the same number for its lines */
  function headerOffset() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bh-header-offset')) || 0;
  }
  function initNav(nav) {
    if (nav.dataset.s26Ready) return; nav.dataset.s26Ready = '1';
    const list = nav.querySelector('.s26nav__list'), ind = nav.querySelector('[data-nav-ind]'), pill = nav.querySelector('.s26nav__pill');
    const pairs = [];
    nav.querySelectorAll('[data-nav-link]').forEach((a) => {
      let t = null;
      try { t = document.querySelector(a.getAttribute('href')); } catch (e) {}
      if (!t) { a.closest('li').hidden = true; return; }
      pairs.push([a, t]);
    });
    if (!pairs.length) { nav.hidden = true; return; }
    let hdr = headerOffset(), shown, barH = nav.offsetHeight, tops = [], wrapTop = 0;
    const wrap = nav.parentElement;
    const line = () => hdr + barH + 24;
    /* page positions, measured once and again only when the page's height changes —
       reading layout on every scroll frame was the other half of the stall */
    const measure = () => {
      const y = scrollY;
      tops = pairs.map(([, t]) => (t.closest('.shopify-section') || t).getBoundingClientRect().top + y);
      const prev = wrap.previousElementSibling;
      wrapTop = prev ? prev.getBoundingClientRect().bottom + y : 0;
      barH = nav.offsetHeight || barH;
    };
    measure();
    function place(a) {
      if (!a) { ind.style.opacity = '0'; return; }
      ind.style.width = a.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      ind.style.opacity = '1';
    }
    function update() {
      const y = scrollY;
      /* visible only while stuck under the header, so it never sits on the page as a stray strip */
      nav.classList.toggle('is-stuck', y > 10 && wrapTop - y <= hdr + 1);
      /* the last section whose top has passed under the bars; none above the first.
         Judged by the whole section's top edge: anchors sit inside the section's top padding,
         so going by the anchor lit a link only once its heading was already at the bar */
      let cur = null;
      const L = line();
      pairs.forEach(([a], i) => { if (tops[i] - y <= L) cur = a; });
      if (cur === shown) return;
      pairs.forEach(([a]) => (a === cur ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
      if (shown === undefined) ind.style.transition = 'none';
      place(cur);
      if (shown === undefined) { void ind.offsetWidth; ind.style.transition = ''; }
      shown = cur;
      if (cur) {
        const l = cur.offsetLeft;
        if (l < list.scrollLeft || l + cur.offsetWidth > list.scrollLeft + list.clientWidth)
          list.scrollTo({ left: l - 16, behavior: reduced ? 'auto' : 'smooth' });
      }
    }
    let raf = 0;
    addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    /* follow the header the moment its bar slides in or away */
    document.addEventListener('bh:header-offset', (e) => { const h = e.detail.offset; if (h !== hdr) { hdr = h; cancelAnimationFrame(raf); raf = requestAnimationFrame(update); } });
    /* re-measure when the page's height changes: images arriving, the plan opening, a list unfolding */
    if ('ResizeObserver' in window) { let rq = 0; new ResizeObserver(() => { cancelAnimationFrame(rq); rq = requestAnimationFrame(() => { measure(); update(); }); }).observe(document.body); }
    addEventListener('resize', () => { hdr = headerOffset(); measure(); place(shown || null); update(); }, { passive: true });
    nav.addEventListener('click', (e) => {
      const a = e.target.closest('[data-nav-link]'); if (!a) return;
      const pr = pairs.find(([x]) => x === a); if (!pr) return;
      e.preventDefault();
      /* land with the section's top clear of the header and this menu */
      const y = pr[1].getBoundingClientRect().top + scrollY - (hdr + barH + 12);
      scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
    });
    update();
    /* the header can settle after fonts/images load */
    addEventListener('load', () => { hdr = headerOffset(); measure(); update(); });
  }

  /* ---------- bundles: products meet when the card arrives; the button opens the bundle product ---------- */
  function initBundle(card) {
    if (card.dataset.s26Ready) return; card.dataset.s26Ready = '1';
    if ('IntersectionObserver' in window && !reduced) {
      const o = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { o.disconnect(); card.classList.add('is-met'); } }, { threshold: .3 });
      o.observe(card);
    } else card.classList.add('is-met');
    /* the bundle product's price follows the chosen set */
    const sel = card.querySelector('select[data-bd-v]'), price = card.querySelector('[data-bd-price]');
    if (sel && price) sel.addEventListener('change', () => { const o = sel.selectedOptions[0]; if (o && o.dataset.price) setText(price, o.dataset.price); });
    /* the button opens the bundle product's page, on the set picked here */
    const link = card.querySelector('a[data-bd-link]');
    if (sel && link) {
      const base = link.getAttribute('href').split('?')[0];
      const point = () => { if (sel.value) link.setAttribute('href', base + '?variant=' + sel.value); };
      sel.addEventListener('change', point); point();
    }
  }

  /* ---- Admit one ticket: dithered warp texture (WebGL) + pointer tilt with a glare ---- */
  const TK_FS = `#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
uniform float u_t; uniform vec2 u_res; uniform float u_px; uniform float u_ratio; uniform vec3 u_back; uniform vec3 u_front;
float h21(vec2 p){ p = fract(p * vec2(.3183099, .3678794)) + .1; p += dot(p, p + 19.19); return fract(p.x * p.y); }
void main(){
  float t = .5 * u_t;
  float px = u_px * u_ratio;
  vec2 cp = (floor((gl_FragCoord.xy - .5 * u_res) / px) + .5) * px;
  vec2 uv = cp / u_ratio * .003;
  for (float i = 1.; i < 6.; i++) { uv.x += .6 / i * cos(i * 2.5 * uv.y + t); uv.y += .6 / i * cos(i * 1.5 * uv.x + t); }
  float sh = .15 / max(.001, abs(sin(t - uv.y - uv.x)));
  sh = smoothstep(.02, 1., sh);
  float r = step(.5, sh + step(h21(cp), sh) - .5);
  gl_FragColor = vec4(mix(u_back, u_front, r), 1.);
}`;
  function hex3(h) { const m = /^#?([0-9a-f]{6})$/i.exec(h || ''); if (!m) return null; const n = parseInt(m[1], 16); return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255]; }
  function tkTexture(tk) {
    const back = hex3(tk.dataset.back), front = hex3(tk.dataset.front);
    if (!back || !front) return;
    const cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    const gl = cv.getContext('webgl', { antialias: false, alpha: false, premultipliedAlpha: false });
    if (!gl) return;
    const sh = (type, src) => { const o = gl.createShader(type); gl.shaderSource(o, src); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; };
    const vs = sh(gl.VERTEX_SHADER, 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}'), fs = sh(gl.FRAGMENT_SHADER, TK_FS);
    if (!vs || !fs) return;
    const pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return;
    gl.useProgram(pr);
    gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    const U = (n) => gl.getUniformLocation(pr, n);
    const uT = U('u_t'), uRes = U('u_res'), uRatio = U('u_ratio');
    gl.uniform1f(U('u_px'), .5); gl.uniform3fv(U('u_back'), back); gl.uniform3fv(U('u_front'), front);
    tk.prepend(cv);
    let ratio = 2, raf = 0, on = false, t0 = performance.now();
    const size = () => {
      const r = tk.getBoundingClientRect();
      ratio = Math.min(2, Math.max(1.5, window.devicePixelRatio || 1));
      cv.width = Math.max(1, Math.round(r.width * ratio)); cv.height = Math.max(1, Math.round(r.height * ratio));
      gl.viewport(0, 0, cv.width, cv.height); gl.uniform2f(uRes, cv.width, cv.height); gl.uniform1f(uRatio, ratio);
    };
    const draw = (now) => { gl.uniform1f(uT, ((now - t0) / 1000) * .4); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); };
    const loop = (now) => { draw(now); raf = on ? requestAnimationFrame(loop) : 0; };
    const play = () => { if (reduced) { draw(t0 + 4000); return; } if (!raf && on) raf = requestAnimationFrame(loop); };
    size();
    new ResizeObserver(() => { size(); if (!raf) draw(reduced ? t0 + 4000 : performance.now()); }).observe(tk);
    new IntersectionObserver((es) => { on = es[0].isIntersecting && !document.hidden; on ? play() : (cancelAnimationFrame(raf), raf = 0); }, { rootMargin: '120px' }).observe(tk);
    document.addEventListener('visibilitychange', () => { if (document.hidden) { on = false; cancelAnimationFrame(raf); raf = 0; } else { const r = tk.getBoundingClientRect(); on = r.bottom > -120 && r.top < innerHeight + 120; play(); } });
    draw(t0 + 4000);
  }
  function tkTilt(tk) {
    if (reduced || !fine.matches || !tk.id) return;
    const st = document.createElement('style'); document.head.appendChild(st);
    const rule = (v) => { st.textContent = '#' + CSS.escape(tk.id) + '{' + v + '}'; };
    let raf = 0, last = null;
    const MAX = 9;
    const apply = () => {
      raf = 0; if (!last) return;
      const r = tk.getBoundingClientRect();
      const x = Math.min(1, Math.max(0, (last.clientX - r.left) / r.width)), y = Math.min(1, Math.max(0, (last.clientY - r.top) / r.height));
      rule('--ry:' + ((x - .5) * 2 * MAX).toFixed(2) + 'deg;--rx:' + ((.5 - y) * 2 * MAX).toFixed(2) + 'deg;--sc:1.02;--gx:' + (x * 100).toFixed(1) + '%;--gy:' + (y * 100).toFixed(1) + '%');
    };
    tk.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'mouse') return; tk.classList.add('is-tilting'); });
    tk.addEventListener('pointermove', (e) => { if (e.pointerType !== 'mouse') return; last = e; if (!raf) raf = requestAnimationFrame(apply); });
    tk.addEventListener('pointerleave', () => { last = null; cancelAnimationFrame(raf); raf = 0; tk.classList.remove('is-tilting'); rule(''); });
  }
  /* prize wheel: spins in once when it reaches the screen; hovering, focusing or pressing a prize
     turns the wheel so that prize sits under the pointer (CSS transition on one custom property) */
  function initWheel(w) {
    if (w.dataset.wheelBound) return; w.dataset.wheelBound = '1';
    const disc = w.querySelector('[data-wheel-disc]'), sec = w.closest('.sof');
    const m = +w.dataset.m || 1, n = +w.dataset.n || 1, seg = 360 / m;
    const btns = sec ? [...sec.querySelectorAll('[data-wheel-to]')] : [];
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let rot = 0, cur = -1;
    const set = (r) => { rot = r; disc.style.setProperty('--rot', r.toFixed(2) + 'deg'); };
    function to(i) {
      if (i === cur) return; cur = i;
      btns.forEach((b, k) => b.setAttribute('aria-pressed', k === i ? 'true' : 'false'));
      let best = null;
      for (let j = i; j < m; j += n) {
        const want = -j * seg, d = (((rot - want) % 360) + 360) % 360;
        if (best === null || d < best) best = d;
      }
      set(rot - best);
    }
    btns.forEach((b) => {
      const i = +b.dataset.wheelTo;
      b.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') to(i); });
      b.addEventListener('focus', () => to(i));
      b.addEventListener('click', () => to(i));
    });
    if (reduce || window.Shopify?.designMode) return;
    w.classList.add('is-intro');
    disc.style.transition = 'none'; set(-720); void disc.offsetWidth; disc.style.transition = '';
    const io = new IntersectionObserver((es) => {
      if (!es[0].isIntersecting) return; io.disconnect();
      requestAnimationFrame(() => { if (cur < 0) set(0); setTimeout(() => w.classList.remove('is-intro'), 2700); });
    }, { threshold: .35 });
    io.observe(w);
  }

  /* ladder: steps rise once when they reach the screen (CSS does the motion) */
  function initLadder(l) {
    if (l.dataset.ladderBound) return; l.dataset.ladderBound = '1';
    if (!('IntersectionObserver' in window)) { l.classList.add('is-in'); return; }
    const io = new IntersectionObserver((es) => { if (es[0].isIntersecting) { io.disconnect(); l.classList.add('is-in'); } }, { threshold: .3 });
    io.observe(l);
  }

  /* terms accordion: GSAP height tween (native <details> without GSAP or under reduced motion) */
  function initRules(list) {
    if (list.dataset.rulesBound) return; list.dataset.rulesBound = '1';
    const src = list.dataset.gsapSrc;
    if (!reduced && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => { if (es[0].isIntersecting) { io.disconnect(); loadGsap(src); } }, { rootMargin: '600px' });
      io.observe(list);
    }
    list.addEventListener('click', (e) => {
      const sum = e.target.closest('.s26ru__sum');
      const G = window.gsap;
      if (!sum || !G || reduced) return;
      const d = sum.parentElement, body = d.querySelector('.s26ru__body');
      if (!body) return;
      e.preventDefault();
      G.killTweensOf(body);
      if (d.open && !d.classList.contains('is-closing')) {
        d.classList.add('is-closing');
        G.set(body, { overflow: 'hidden' });
        G.fromTo(body, { height: body.offsetHeight, opacity: 1 }, { height: 0, opacity: 0, duration: 0.32, ease: 'power3.inOut', onComplete: () => { d.open = false; d.classList.remove('is-closing'); G.set(body, { clearProps: 'height,opacity,overflow' }); } });
      } else {
        d.classList.remove('is-closing');
        d.open = true;
        G.fromTo(body, { height: 0, opacity: 0, overflow: 'hidden' }, { height: body.scrollHeight, opacity: 1, duration: 0.42, ease: 'power3.out', onComplete: () => G.set(body, { clearProps: 'height,opacity,overflow' }) });
      }
    });
  }

  function initAdmit(wrap) {
    if (wrap.dataset.sofAdmitOn) return;
    wrap.dataset.sofAdmitOn = '1';
    const tk = wrap.querySelector('.sof__tk');
    if (!tk) return;
    try { tkTexture(tk); } catch (e) { /* the CSS gradient stays */ }
    tkTilt(tk);
  }

  function init(scope) {
    scope.querySelectorAll('[data-s26-phases]').forEach((r) => { if (!roots.has(r)) { roots.add(r); tickRoot(r); } });
    tickGates(scope);
    scope.querySelectorAll('[data-s26-split]').forEach(splitWords);
    if (io && !reduced) {
      scope.querySelectorAll('[data-s26-split], .s26-r, ' + AUTO).forEach((el) => {
        if (el.dataset.s26Seen) return;
        el.dataset.s26Seen = '1';
        if (!el.classList.contains('s26-split')) el.classList.add('s26-r');
        /* anything already on screen at load arrives with the page, not after a scroll */
        io.observe(el);
      });
    }
    scope.querySelectorAll(LOOPERS).forEach((m) => { if (!marquees.has(m)) { marquees.add(m); if (offIO) offIO.observe(m); } });
    scope.querySelectorAll('[data-s26-spend]').forEach(initSpend);
    scope.querySelectorAll('[data-s26-boost]').forEach(initBoost);
    scope.querySelectorAll('[data-s26-cal]').forEach(initCalendar);
    scope.querySelectorAll('[data-s26-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-s26-tl]').forEach(initTimeline);
    scope.querySelectorAll('[data-s26-guide]').forEach(initGuide);
    scope.querySelectorAll('[data-sof-admit]').forEach(initAdmit);
    scope.querySelectorAll('[data-sof-wheel]').forEach(initWheel);
    scope.querySelectorAll('[data-sof-ladder]').forEach(initLadder);
    scope.querySelectorAll('[data-s26-rules]').forEach(initRules);
    scope.querySelectorAll('[data-s26-nav]').forEach(initNav);
    scope.querySelectorAll('[data-s26-flash]').forEach(initFlash);
    scope.querySelectorAll('[data-s26-deals]').forEach(initDeals);
    scope.querySelectorAll('[data-s26-time]').forEach(initTime);
    if (scope.querySelector('[data-s26-peek]')) bindPeek();
    bindPointer();
  }

  /* arriving with #section (the homepage planner's offer links): the browser jumps before the pictures
     above have their height, so line the anchor up again until the page settles or the visitor moves */
  function initHash() {
    let el = null;
    try { el = location.hash.length > 1 ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch (e) { el = null; }
    if (!el || !el.classList.contains('bts-anchor')) return;
    let stop = false;
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach((t) => addEventListener(t, () => { stop = true; }, { once: true, passive: true }));
    const align = () => { if (!stop) el.scrollIntoView({ block: 'start', behavior: 'instant' }); };
    if (document.readyState !== 'complete') addEventListener('load', align, { once: true });
    [300, 800, 1500, 2500, 4000].forEach((t) => setTimeout(align, t));
  }

  window.__sale26 = { init };
  const go = () => { init(document); initHash(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
